import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useLocation, useHistory, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { format } from 'date-fns';
import CryptoJS from 'crypto-js';
import * as Yup from 'yup';
import { Form } from '@unform/web';
import { BiLoaderAlt } from 'react-icons/bi';
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';
import { BsFillQuestionCircleFill } from 'react-icons/bs';

import omitEmpty from 'omit-empty';
import ApiClient from '~/utils/ApiClient';

import Chat from '~/components/Chat/chat';

import {
  Input,
  Select,
  Textarea,
  ChoiceButtonLocacao,
  File,
  FormChoiceButton,
  InputNoForm,
} from '~/components/Forms';

import {
  PageContainer,
  ActionInputMulti,
  MultiInputContainer,
  ConditionalContainer,
  LimiterInputWidth,
  ContainerMultiInputActions,
  TooltipContainer,
} from '~/styles/components';

import { NavBarHeader, ModalPorteFilmagem } from '~/components/Usuario';

import {
  BannerContent,
  TextBanner,
  PageContent,
  PageFooter,
  BoxHeader,
} from '~/pages/Usuario/styles';

import { Wrap, MainLoading } from './styles';

import ComplementoNumeroListActions from '~/store/ducks/complemento-numero-list';
import EfeitoEspecialListActions from '~/store/ducks/efeito-especial-list';
import SomFilmagemListActions from '~/store/ducks/som-filmagem-list';
import EquipamentoFilmagemListActions from '~/store/ducks/equipamento-filmagem-list';
import ImpactoListActions from '~/store/ducks/impacto-list';
import FinalidadeBaseListActions from '~/store/ducks/finalidade-base-apoio-list';
import LocalGeradorListActions from '~/store/ducks/local-gerador-list';

import { showModalMessage } from '~/services/notification';

import Button from '~/components/Button';
import Documents from '~/components/Documents/Documents';
import {
  ModalidadePagamento,
  ObservacoesChat,
  ValorLocacao,
} from '~/components/Admin';
import { useList } from '~/hooks/useFunction';
import LocacaoDocs from '~/pages/Usuario/Locacoes/LocacaoDocs';
import LogoIcon from '~/components/LogoIcon';
import WorkStatusSwitch from '~/components/Admin/WorkStatusSwitch';
import Header from '~/components/Header';
import BannerHeader from '~/components/BannerHeader';
import WhiteBox from '~/components/WhiteBox';
import {
  getBrowserTransformDate,
  validDateArray,
  validHourArray,
} from '~/pages/Usuario/Locacoes/functions/date-hour-utils';
import { ActionButton } from '~/components/Forms/FormChoiceButton/styles';
import tenancy_env from '~/utils/MultiTenancyUtil';
import clientResources from '~/data/clientResources';
import { DateFormMultiInput } from '~/components/Forms/DateFormMultiInput';
import { HourFormMultiInput } from '~/components/Forms/HourFormMultiInput';

export const selectCustomStyles = {
  option: provided => ({
    ...provided,
    borderBottom: `1px #ddd solid`,
    color: '#828282',
    backgroundColor: '#f2f2f2',
    padding: 16,
    fontFamily: 'PoppinsSemiBold',
    fontSize: 14,
    boxSizing: 'border-box',
    outline: 'none',
  }),
  input: provided => ({
    ...provided,
    padding: 16,
    fontSize: 14,
    margin: 0,
  }),
  container: provided => ({
    ...provided,
    padding: 0,
    marginBottom: 15,
  }),
  valueContainer: provided => ({
    ...provided,
    padding: 0,
  }),
  placeholder: provided => ({
    ...provided,
    marginLeft: 16,
    fontSize: 14,
    padding: 0,
    fontFamily: 'PoppinsSemiBold',
  }),
  control: provided => ({
    ...provided,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#d0d0d0',
    borderRadius: 2,
    boxSizing: 'border-box',
    backgroundColor: '#f2f2f2',
    boxShadow: '0 3px 12px rgba(0, 0, 0, 0.075)',
    height: 48,
    outline: 'none',
  }),
  singleValue: provided => ({
    ...provided,
    marginLeft: 16,
    fontSize: 14,
    color: '#828282',
  }),
  indicatorsContainer: provided => ({
    ...provided,
    fontSize: 10,
    color: '#828282',
  }),
};

const optionsTipoBloqueio = [
  {
    value: 'todas_as_faixas',
    label: 'De todas as faixas',
  },
  {
    value: 'algumas_faixas',
    label: 'De algumas faixas',
  },
];

export default function UtilizacaoVia() {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const dadoState = location.state;
  const isAdminRequest = dadoState?.isAdminRequest || false;

  // refs
  const formRef = useRef();
  const croquiFileRef = useRef(null);
  const relatorioArteFileRef = useRef(null);
  const conteudoProjecaoRef = useRef(null);
  const iluminacaoFileRef = useRef(null);

  // states
  const [responseLocation, setResponseLocation] = useState();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [errorsForm, setErrorsForm] = useState({});
  const [openModalPorteFilmagem, setOpenModalPorteFilmagem] = useState(false);
  const [baseApoio, setBaseApoio] = useState(null);

  // states multi input
  const [horasEntradaInputs, setHorasEntradaInputs] = useState([
    { inicio: '', fim: '' },
  ]);

  const [datasEntradaInputs, setDatasEntradaInputs] = useState([
    { data_entrada: '' },
  ]);
  const [horasSaidaInputs, setHorasSaidaInputs] = useState([
    { inicio: '', fim: '' },
  ]);

  const [datasSaidaInputs, setDatasSaidaInputs] = useState([
    { data_saida: '' },
  ]);

  const [horasFilmagemInputs, setHorasFilmagemInputs] = useState([
    { inicio: '', fim: '' },
  ]);
  const [datasFilmagemInputs, setDatasFilmagemInputs] = useState([
    { data_filmagem: '' },
  ]);

  // states choices
  const [associarLocacao, setAssociarLocacao] = useState(null);
  const [localFilmagem, setLocalFilmagem] = useState(null);
  const [tipoFilmagem, setTipoFilmagem] = useState(null);
  const [tipoBloqueioAlgumasFaixas, setTipoBloqueioAlgumasFaixas] =
    useState(null);
  const [filmagemExternaEm, setFilmagemExternaEm] = useState(null);
  const [intervencaoArte, setIntervencaoArte] = useState(null);
  const [gerador, setGerador] = useState(null);
  const [blimpado, setBlimpado] = useState(null);
  const [baseLocal, setBaseLocal] = useState(null);
  const [captacaoSomDireto, setCaptacaoSomDireto] = useState(null);
  const [somFilmagem, setSomFilmagem] = useState(null);
  const [drone, setDrone] = useState(null);
  const [efeitosEspeciais, setEfeitosEspeciais] = useState(null);
  const [projecao, setProjecao] = useState(null);
  const [projecaoLogo, setProjecaoLogo] = useState(null);
  const [desligarLuz, setDesligarLuz] = useState(null);
  const [reservasVagas, setReservasVagas] = useState(null);
  const [publicoPrivado, setPublicoPrivado] = useState(null);

  // select options
  const [filmagemInternaOpts, setFilmagemInternaOpts] = useState(null);
  const [filmagemExternaOpts, setFilmagemExternaOpts] = useState(null);
  const [finalidadeBloqueioOpts, setFinalidadeBloqueioOpts] = useState(null);

  // state files
  const [croquiFile, setCroquiFile] = useState(null);
  const [dataCroquiFile, setDataCroquiFile] = useState(null);
  const [dataRelatorioArteFile, setDataRelatorioArteFile] = useState(null);
  const [relatorioArteFile, setRelatorioArteFile] = useState(null);
  const [dataConteudoProjecaoFile, setDataConteudoProjecaoFile] =
    useState(null);
  const [conteudoProjecaoFile, setConteudoProjecaoFile] = useState(null);
  const [dataIluminacaoFile, setDataIluminacaoFile] = useState(null);
  const [iluminacaoFile, setIluminacaoFile] = useState(null);

  // state outro fields
  const [showFinalidadeBloqueio, setShowFinalidadeBloqueio] = useState(null);
  const [showDescrAltoImpactoLocalField, setShowDescrAltoImpactoLocalField] =
    useState(false);
  const [showOutroEquipamentoField, setShowOutroEquipamentoField] =
    useState(false);
  const [showOutroSomFilmagemField, setShowOutroSomFilmagemField] =
    useState(false);
  const [showOutroFinalidadeField, setShowOutroFinalidadeField] =
    useState(false);
  const [selectedFilmagemInternaOpt, setSelectedFilmagemInternaOpt] =
    useState(null);
  const [selectedFilmagemExternaOpt, setSelectedFilmagemExternaOpt] =
    useState(null);
  const [
    showDescrEquipamentoFilmagemField,
    setShowDescrEquipamentoFilmagemField,
  ] = useState(false);
  const [showDescrSomFilmagemField, setShowDescrSomFilmagemField] =
    useState(false);

  // selectors
  const utilizacaoAssociacaoList = useList({
    url: `utilizacao-associacao/${dadoState?.uuid}?paginate=false`,
  });

  const { data: complementoNumeroSelectList } = useSelector(
    state => state.complementoNumeroList,
  );
  const { data: equipamentosSelectList } = useSelector(
    state => state.equipamentoFilmagemList,
  );
  const { data: somFilmagemSelectList } = useSelector(
    state => state.somFilmagemList,
  );
  const { data: efeitoEspecialSelectList } = useSelector(
    state => state.efeitoEspecialList,
  );
  const { data: impactoSelectList } = useSelector(state => state.impactoList);

  const { data: finalidadeSelectList } = useSelector(
    state => state.finalidadeBaseApoioList,
  );
  const { data: localGeradorSelectList } = useSelector(
    state => state.localGeradorList,
  );

  const filmagemInternaListFetchCB = useCallback(async () => {
    const resp = await ApiClient.doRequest({
      uri: `ld-tipo-interna`,
      method: ApiClient.GET,
      expectedStatus: 200,
    });

    const list = resp?.data?.data.map(({ uuid, name }) => ({
      value: uuid,
      label: name,
    }));

    setFilmagemInternaOpts(list);
  }, []);

  const filmagemExternaListFetchCB = useCallback(async () => {
    const resp = await ApiClient.doRequest({
      uri: `ld-tipo-externa`,
      method: ApiClient.GET,
      expectedStatus: 200,
    });

    const list = resp?.data?.data.map(({ uuid, name }) => ({
      value: uuid,
      label: name,
    }));

    setFilmagemExternaOpts(list);
  }, []);

  const finalidadeBloqueioListFetchCB = useCallback(async () => {
    const resp = await ApiClient.doRequest({
      uri: `ld-finalidade-bloqueio`,
      method: ApiClient.GET,
      expectedStatus: 200,
    });

    const list = resp?.data?.data.map(({ uuid, name }) => ({
      value: uuid,
      label: name,
    }));

    setFinalidadeBloqueioOpts(list);
  }, []);

  // effects
  useEffect(() => {
    dispatch(ImpactoListActions.showRequest());
    dispatch(ComplementoNumeroListActions.showRequest());
    dispatch(EquipamentoFilmagemListActions.showRequest());
    dispatch(SomFilmagemListActions.showRequest());
    dispatch(EfeitoEspecialListActions.showRequest());
    dispatch(FinalidadeBaseListActions.showRequest());
    dispatch(LocalGeradorListActions.showRequest());
    filmagemExternaListFetchCB();
    filmagemInternaListFetchCB();
    finalidadeBloqueioListFetchCB();
  }, [
    dispatch,
    filmagemExternaListFetchCB,
    filmagemInternaListFetchCB,
    finalidadeBloqueioListFetchCB,
  ]);

  // Busca dados da locação
  const visualizacaoDadosCB = useCallback(async () => {
    if (dadoState?.viewData) {
      setLoading(true);
      const resp = await ApiClient.doRequest({
        uri: `locacao-utilizacao-via/${dadoState?.viewData?.uuid}`,
        method: ApiClient.GET,
        expectedStatus: 200,
      });

      const respLoc = resp?.data?.data;

      // set temp variables
      const blimpadoTmp =
        respLoc?.locacao_default.blimpado === null
          ? null
          : respLoc?.locacao_default.blimpado === 1;

      const projecaoLogoTmp =
        typeof respLoc?.locacao_default.porcentagem_projecao === 'number' ||
        typeof respLoc?.locacao_default.area_tempo_projeção === 'string';

      const publicoPrivadoTmp =
        respLoc?.locacao_default?.imovel_publico_privado === null
          ? null
          : respLoc?.locacao_default?.imovel_publico_privado === 1;

      const filmagemExternaEmTmp =
        respLoc?.filmagem_externa_em === null
          ? null
          : respLoc?.filmagem_externa_em === 1;

      const fileCroqui = respLoc?.locacao_default.files?.filter(
        file => file.name === 'Arquivo Croqui',
      );
      const fileArte = respLoc?.locacao_default.files?.filter(
        file => file.name === 'Relatório de Arte',
      );
      const fileProjecao = respLoc?.locacao_default.files?.filter(
        file => file.name === 'Arquivo Projeção',
      );
      const fileLuz = respLoc?.locacao_default.files?.filter(
        file => file.name === 'Arquivo Iluminação',
      );

      // set choices buttons
      setAssociarLocacao(Object.values(respLoc?.associada || {}).length > 0);
      setBaseApoio(
        typeof respLoc?.base_address === 'string' &&
          typeof respLoc?.base_num === 'string',
      );
      setLocalFilmagem(!(typeof respLoc?.address_temp === 'string'));
      setTipoFilmagem(Object.values(respLoc?.ld_tipo_interna || {}).length > 0);
      setFilmagemExternaEm(filmagemExternaEmTmp);
      setIntervencaoArte(
        typeof respLoc?.locacao_default.desc_intervencao_arte === 'string' ||
          fileArte?.length > 0,
      );
      setBlimpado(blimpadoTmp);
      setGerador(
        blimpadoTmp !== null ||
          Object.values(respLoc?.ld_local_gerador || {}).length > 0,
      );
      setBaseLocal(
        Object.values(respLoc?.locacao_default.ld_finalidade_base_apoio || [])
          .length > 0 ||
          typeof respLoc?.locacao_default.local_base_apoio === 'string' ||
          typeof respLoc?.locacao_default.dimensao_base_apoio === 'string' ||
          typeof respLoc?.locacao_default.quantidade_barracas === 'string',
      );
      setCaptacaoSomDireto(respLoc?.locacao_default.captação_som_direto === 1);
      setSomFilmagem(
        Object.values(respLoc?.locacao_default.ld_som_filmagem || []).length >
          0,
      );
      setDrone(respLoc?.locacao_default.drone === 1);
      setEfeitosEspeciais(
        Object.values(respLoc?.locacao_default.ld_efeitos_especiais || [])
          .length > 0,
      );
      setProjecao(
        typeof respLoc?.locacao_default?.estrutura_projecao === 'string' ||
          typeof respLoc?.locacao_default?.instalacao_estrutura_projecao ===
            'string' ||
          publicoPrivadoTmp ||
          projecaoLogoTmp ||
          fileProjecao?.length > 0,
      );
      setPublicoPrivado(publicoPrivadoTmp);
      setProjecaoLogo(projecaoLogoTmp);
      setDesligarLuz(fileLuz?.length > 0);

      setReservasVagas(
        Object.values(respLoc?.locacao_via_externa || []).length > 0,
      );

      // set campos 'multi'
      setDatasFilmagemInputs(
        respLoc?.locacao_default?.dates_locacao_default?.map(({ date }) => ({
          data_filmagem: getBrowserTransformDate(date.split(' ')[0], true),
        })),
      );

      setHorasFilmagemInputs(
        respLoc?.locacao_default?.hours_locacao_default?.map(
          ({ inicio, fim }) => ({
            inicio: inicio.substring(0, 5),
            fim: fim.substring(0, 5),
          }),
        ),
      );

      setDatasEntradaInputs(
        respLoc?.base_dates
          ?.filter(({ date_input }) => date_input === 'Entrada')
          ?.map(({ date }) => ({
            data_entrada: getBrowserTransformDate(date.split(' ')[0], true),
          })),
      );

      setDatasSaidaInputs(
        respLoc?.base_dates
          ?.filter(({ date_input }) => date_input === 'Saída')
          ?.map(({ date }) => ({
            data_saida: getBrowserTransformDate(date.split(' ')[0], true),
          })),
      );

      setHorasEntradaInputs(
        respLoc?.base_hours
          ?.filter(({ hour_input }) => hour_input === 'Entrada')
          ?.map(({ inicio, fim }) => ({
            inicio: inicio.substring(0, 5),
            fim: fim.substring(0, 5),
          })),
      );

      setHorasSaidaInputs(
        respLoc?.base_hours
          ?.filter(({ hour_input }) => hour_input === 'Saída')
          ?.map(({ inicio, fim }) => ({
            inicio: inicio.substring(0, 5),
            fim: fim.substring(0, 5),
          })),
      );

      // set campos 'Outro'
      setShowOutroEquipamentoField(
        respLoc?.locacao_default?.ld_equipamento_filmagem?.find(
          equip => equip.name === 'Outro',
        ),
      );
      setShowOutroFinalidadeField(
        respLoc?.locacao_default?.ld_finalidade_base_apoio?.find(
          equip => equip.name === 'outro, descreva',
        ),
      );
      setShowOutroSomFilmagemField(
        respLoc?.locacao_default?.ld_som_filmagem?.find(
          equip => equip.name === 'outro',
        ),
      );
      setShowDescrEquipamentoFilmagemField(
        typeof respLoc?.locacao_default?.descricoes_equipamento_filmagem ===
          'string',
      );
      setShowDescrSomFilmagemField(
        typeof respLoc?.locacao_default?.descricoes_som_filmagem === 'string',
      );
      setShowDescrAltoImpactoLocalField(
        typeof respLoc?.locacao_default?.descr_alto_impacto_local === 'string',
      );

      // set select default values
      formRef.current?.setFieldValue('ld_impacto_uuid', {
        label: respLoc?.locacao_default?.ld_impacto?.name,
        value: respLoc?.locacao_default?.ld_impacto?.uuid,
      });

      formRef.current?.setFieldValue(
        'ld_equipamento_filmagem',
        respLoc?.locacao_default?.ld_equipamento_filmagem?.map(lfba => {
          return {
            label: lfba.name,
            value: lfba.uuid,
          };
        }),
      );

      formRef.current?.setFieldValue('ld_local_gerador_uuid', {
        label: respLoc?.ld_local_gerador?.name,
        value: respLoc?.ld_local_gerador?.uuid,
      });

      formRef.current?.setFieldValue('ld_tipo_interna_uuid', {
        label: respLoc?.ld_tipo_interna?.name,
        value: respLoc?.ld_tipo_interna?.uuid,
      });

      formRef.current?.setFieldValue('ld_tipo_externa_uuid', {
        label: respLoc?.ld_tipo_externa?.name,
        value: respLoc?.ld_tipo_externa?.uuid,
      });

      formRef.current?.setFieldValue(
        'tipo_bloqueio_interna',
        optionsTipoBloqueio.filter(
          tb => tb.value === respLoc?.tipo_bloqueio_interna,
        ),
      );

      formRef.current?.setFieldValue(
        'tipo_bloqueio_externa',
        optionsTipoBloqueio.filter(
          tb => tb.value === respLoc?.tipo_bloqueio_externa,
        ),
      );

      formRef.current?.setFieldValue(
        'ld_finalidade_base_apoio',
        respLoc?.locacao_default?.ld_finalidade_base_apoio?.map(lfba => {
          return {
            label: lfba.name,
            value: lfba.uuid,
          };
        }),
      );

      formRef.current?.setFieldValue(
        'ld_som_filmagem',
        respLoc?.locacao_default?.ld_som_filmagem?.map(ilef => {
          return {
            label: ilef.name,
            value: ilef.uuid,
          };
        }),
      );

      formRef.current?.setFieldValue('ld_efeitos_especiais_uuid', {
        label: respLoc?.locacao_default?.ld_efeitos_especiais?.name,
        value: respLoc?.locacao_default?.ld_efeitos_especiais?.uuid,
      });

      formRef.current?.setFieldValue('ld_complemento_numero_uuid', {
        label: respLoc?.ld_complemento_numero?.name,
        value: respLoc?.ld_complemento_numero?.uuid,
      });

      formRef.current?.setFieldValue('ld_finalidade_bloqueio_uuid', {
        label: respLoc?.ld_finalidade_bloqueio?.name,
        value: respLoc?.ld_finalidade_bloqueio?.uuid,
      });

      formRef.current?.setFieldValue('utilizacao_associacao', {
        label: `${respLoc?.associada?.name_view} - ${respLoc?.associada?.protocol}`,
        value: {
          uuid: respLoc?.associada?.uuid,
          endpoint: respLoc?.associada?.endpoint,
        },
      });

      setSelectedFilmagemInternaOpt(respLoc?.ld_tipo_interna?.name);
      setSelectedFilmagemExternaOpt(respLoc?.ld_tipo_externa?.name);
      setTipoBloqueioAlgumasFaixas(
        respLoc?.tipo_bloqueio_externa === 'algumas_faixas' ||
          respLoc?.tipo_bloqueio_interna === 'algumas_faixas',
      );
      setResponseLocation(resp?.data?.data);
      setLoading(false);
    }
  }, [dadoState]);

  useEffect(() => {
    visualizacaoDadosCB();
  }, [visualizacaoDadosCB]);

  const convertBase64 = arquivo => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(arquivo);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = error => {
        reject(error);
      };
    });
  };

  // Verification files
  let fileCroqui = [];
  let fileArte = [];
  let fileProjecao = [];
  let fileLuz = [];

  // Filter files
  fileCroqui = responseLocation?.locacao_default.files?.filter(
    file => file.name === 'Arquivo Croqui',
  );
  fileArte = responseLocation?.locacao_default.files?.filter(
    file => file.name === 'Relatório de Arte',
  );
  fileProjecao = responseLocation?.locacao_default.files?.filter(
    file => file.name === 'Arquivo Projeção',
  );
  fileLuz = responseLocation?.locacao_default.files?.filter(
    file => file.name === 'Arquivo Iluminação',
  );

  // handles files
  function handleIluminacaoFile() {
    return iluminacaoFileRef.current.click();
  }

  function handleProjecaoFile() {
    return conteudoProjecaoRef.current.click();
  }

  function handleCroquiFile() {
    return croquiFileRef.current.click();
  }

  function handleRelatorioArteFile() {
    return relatorioArteFileRef.current.click();
  }

  // handles multi select
  function handleMultiSelectEquipamentos(e) {
    setShowOutroEquipamentoField(!!e?.find(x => x.label === 'Outro'));
    setShowDescrEquipamentoFilmagemField(
      e?.some(equip => equip.label?.includes(':')) || false,
    );

    setFormData(state => ({
      ...state,
      ld_equipamento_filmagem: Array.isArray(e) ? e.map(x => x.value) : [],
    }));
  }

  function handleMultiSelectSomFilmagem(e) {
    setShowOutroSomFilmagemField(!!e?.find(x => x.label === 'outro'));
    setShowDescrSomFilmagemField(
      e?.some(equip => equip.label?.includes('descrever')) || false,
    );

    setFormData(state => ({
      ...state,
      ld_som_filmagem: Array.isArray(e) ? e.map(x => x.value) : [],
    }));
  }

  function handleMultiSelectFinalidades(e) {
    setShowOutroFinalidadeField(!!e?.find(x => x.label === 'outro, descreva'));

    setFormData(state => ({
      ...state,
      ld_finalidade_base_apoio: Array.isArray(e) ? e.map(x => x.value) : [],
    }));
  }

  // handles true/false
  function handleBaseApoioTrue(e) {
    e.preventDefault();
    setBaseApoio(true);
    setErrorsForm(state => ({
      ...state,
      baseApoio: false,
    }));
  }

  function handleBaseApoioFalse(e) {
    e.preventDefault();
    setBaseApoio(false);
    setErrorsForm(state => ({
      ...state,
      baseApoio: false,
    }));
  }

  function handleTipoFilmagemTrue(e) {
    e.preventDefault();
    setTipoFilmagem(true);
    setErrorsForm(state => ({
      ...state,
      tipoFilmagem: false,
    }));
  }

  function handleTipoFilmagemFalse(e) {
    e.preventDefault();
    setTipoFilmagem(false);
    setErrorsForm(state => ({
      ...state,
      tipoFilmagem: false,
    }));
  }

  function handleProjecaoLogoTrue(e) {
    e.preventDefault();
    setProjecaoLogo(true);
    setErrorsForm(state => ({
      ...state,
      projecaoLogo: false,
    }));
  }

  function handleProjecaoLogoFalse(e) {
    e.preventDefault();
    setProjecaoLogo(false);
    setErrorsForm(state => ({
      ...state,
      projecaoLogo: false,
    }));
  }

  function handleDesligarLuzTrue(e) {
    e.preventDefault(e);
    setDesligarLuz(true);
    setErrorsForm(state => ({
      ...state,
      desligarLuz: false,
    }));
  }

  function handleDesligarLuzFalse(e) {
    e.preventDefault(e);
    setDesligarLuz(false);
    setErrorsForm(state => ({
      ...state,
      desligarLuz: false,
    }));
  }

  function handleReservasVagasTrue(e) {
    e.preventDefault(e);
    setReservasVagas(true);
    setErrorsForm(state => ({
      ...state,
      reservasVagas: false,
    }));
  }

  function handleReservasVagasFalse(e) {
    e.preventDefault(e);
    setReservasVagas(false);
    setErrorsForm(state => ({
      ...state,
      reservasVagas: false,
    }));
  }

  function handlePublicoPrivadoTrue(e) {
    e.preventDefault();
    setPublicoPrivado(true);
    setErrorsForm(state => ({
      ...state,
      publicoPrivado: false,
    }));
  }

  function handlePublicoPrivadoFalse(e) {
    e.preventDefault();
    setPublicoPrivado(false);
    setErrorsForm(state => ({
      ...state,
      publicoPrivado: false,
    }));
  }

  function handleDroneTue(e) {
    e.preventDefault();
    setDrone(true);
    setErrorsForm(state => ({
      ...state,
      drone: false,
    }));
  }

  function handleDroneFalse(e) {
    e.preventDefault();
    setDrone(false);
    setErrorsForm(state => ({
      ...state,
      drone: false,
    }));
  }

  function handleCaptacaoSomDiretoTrue(e) {
    e.preventDefault();
    setCaptacaoSomDireto(true);
    setErrorsForm(state => ({
      ...state,
      captacaoSomDireto: false,
    }));
  }

  function handleCaptacaoSomDiretoFalse(e) {
    e.preventDefault();
    setCaptacaoSomDireto(false);
    setErrorsForm(state => ({
      ...state,
      captacaoSomDireto: false,
    }));
  }

  function handleLocalFilmagemTrue(e) {
    e.preventDefault();
    setLocalFilmagem(true);
    setErrorsForm(state => ({
      ...state,
      localFilmagem: false,
    }));
  }

  function handleLocalFilmagemFalse(e) {
    e.preventDefault();
    setLocalFilmagem(false);
    setErrorsForm(state => ({
      ...state,
      localFilmagem: false,
    }));
  }

  function handleFilmagemExternaEmTrue(e) {
    e.preventDefault();
    setFilmagemExternaEm(true);
    setErrorsForm(state => ({
      ...state,
      filmagemExternaEm: false,
    }));
  }

  function handleFilmagemExternaEmFalse(e) {
    e.preventDefault();
    setFilmagemExternaEm(false);
    setErrorsForm(state => ({
      ...state,
      filmagemExternaEm: false,
    }));
  }

  function handleIntervencaoArteTrue(e) {
    e.preventDefault();
    setIntervencaoArte(true);
    setErrorsForm(state => ({
      ...state,
      intervencaoArte: false,
    }));
  }

  function handleIntervencaoArteFalse(e) {
    e.preventDefault();
    setIntervencaoArte(false);
    setErrorsForm(state => ({
      ...state,
      intervencaoArte: false,
    }));
  }

  function handleGeradorTrue(e) {
    e.preventDefault();
    setGerador(true);
    setErrorsForm(state => ({
      ...state,
      gerador: false,
    }));
  }

  function handleGeradorFalse(e) {
    e.preventDefault();
    setGerador(false);
    setErrorsForm(state => ({
      ...state,
      gerador: false,
    }));
  }

  function handleBlimpadorTrue(e) {
    e.preventDefault();
    setBlimpado(true);
    setErrorsForm(state => ({
      ...state,
      blimpado: false,
    }));
  }

  function handleBlimpadorFalse(e) {
    e.preventDefault();
    setBlimpado(false);
    setErrorsForm(state => ({
      ...state,
      blimpado: false,
    }));
  }

  function handleBaseLocalTrue(e) {
    e.preventDefault();
    setBaseLocal(true);
    setErrorsForm(state => ({
      ...state,
      baseLocal: false,
    }));
  }

  function handleBaseLocalFalse(e) {
    e.preventDefault();
    setBaseLocal(false);
    setErrorsForm(state => ({
      ...state,
      baseLocal: false,
    }));
  }

  function handleSomFilmagemTrue(e) {
    e.preventDefault(e);
    setSomFilmagem(true);
    setErrorsForm(state => ({
      ...state,
      somFilmagem: false,
    }));
  }

  function handleSomFilmagemFalse(e) {
    e.preventDefault(e);
    setSomFilmagem(false);
    setErrorsForm(state => ({
      ...state,
      somFilmagem: false,
    }));
  }

  function handleEfeitosEspeciaisTrue(e) {
    e.preventDefault(e);
    setEfeitosEspeciais(true);
    setErrorsForm(state => ({
      ...state,
      efeitosEspeciais: false,
    }));
  }

  function handleEfeitosEspeciaisFalse(e) {
    e.preventDefault(e);
    setEfeitosEspeciais(false);
    setErrorsForm(state => ({
      ...state,
      efeitosEspeciais: false,
    }));
  }

  function handleProjecaoTrue(e) {
    e.preventDefault();
    setProjecao(true);
    setErrorsForm(state => ({
      ...state,
      projecao: false,
    }));
  }

  function handleProjecaoFalse(e) {
    e.preventDefault();
    setProjecao(false);
    setErrorsForm(state => ({
      ...state,
      projecao: false,
    }));
  }

  function handleAssociarLocacaoTrue(e) {
    e.preventDefault();
    setAssociarLocacao(true);
    setErrorsForm(state => ({
      ...state,
      associarLocacao: false,
    }));
  }

  function handleAssociarLocacaoFalse(e) {
    e.preventDefault();
    setAssociarLocacao(false);
    setErrorsForm(state => ({
      ...state,
      associarLocacao: false,
    }));
  }

  async function handleFileChange(event) {
    event.preventDefault();
    const { name } = event.target;
    let sizeError = false;

    const file = event.target.files[0];
    const base64 = await convertBase64(file);

    console.log(file.size);
    if (file.size > 20971520) {
      await showModalMessage({
        type: 'error',
        text: 'Limite de upload excedido! Tamanho máximo permitido por arquivo: 20MB',
      });
      sizeError = true;
    }

    if (name === 'croqui_file') {
      if (sizeError) {
        setCroquiFile(null);
        setDataCroquiFile(null);
        setErrorsForm(state => ({
          ...state,
          croquiFile: true,
        }));
        return;
      }
      setCroquiFile(base64.split('base64,'));
      setDataCroquiFile(file);
      setErrorsForm(state => ({
        ...state,
        croquiFile: false,
      }));
    }

    if (name === 'relatorio_arte_file') {
      if (sizeError) {
        setRelatorioArteFile(null);
        setDataRelatorioArteFile(null);
        setErrorsForm(state => ({
          ...state,
          relatorioArteFile: true,
        }));
        return;
      }
      setRelatorioArteFile(base64.split('base64,'));
      setDataRelatorioArteFile(file);
      setErrorsForm(state => ({
        ...state,
        relatorioArteFile: false,
      }));
    }

    if (name === 'conteudo_projecao_file') {
      if (sizeError) {
        setConteudoProjecaoFile(null);
        setDataConteudoProjecaoFile(null);
        setErrorsForm(state => ({
          ...state,
          conteudoProjecaoFile: true,
        }));
        return;
      }
      setConteudoProjecaoFile(base64.split('base64,'));
      setDataConteudoProjecaoFile(file);
      setErrorsForm(state => ({
        ...state,
        conteudoProjecaoFile: false,
      }));
    }

    if (name === 'iluminacao_file') {
      if (sizeError) {
        setIluminacaoFile(null);
        setDataIluminacaoFile(null);
        setErrorsForm(state => ({
          ...state,
          iluminacaoFile: true,
        }));
        return;
      }
      setIluminacaoFile(base64.split('base64,'));
      setDataIluminacaoFile(file);
      setErrorsForm(state => ({
        ...state,
        iluminacaoFile: false,
      }));
    }

    setFormData(state => ({ ...state, [name]: base64.split('base64,')[1] }));
  }

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData(state => ({ ...state, [name]: value }));
  }

  function handleSelectChange(name, option) {
    const value = option ? option.value : null;
    setFormData(state => ({ ...state, [name]: value }));
  }

  function handleSelectFilmagem(name, option) {
    const value = option ? option.value : null;
    setFormData(state => ({ ...state, [name]: value }));

    if (tipoFilmagem === true) {
      setSelectedFilmagemInternaOpt(option?.label);
    } else {
      setSelectedFilmagemExternaOpt(option?.label);
    }
  }

  function handleSelectFinalidadeBloqueio(name, option) {
    const value = option ? option.value : null;
    setFormData(state => ({ ...state, [name]: value }));

    setShowFinalidadeBloqueio(option?.label);
  }

  async function handleValidationFields(data) {
    try {
      formRef.current.setErrors({});
      const defaultMsg = 'Obrigatório';

      const schema = Yup.object().shape({
        ld_impacto_uuid: Yup.string()
          .typeError(defaultMsg)
          .required(defaultMsg),
        utilizacao_associacao: Yup.string()
          .typeError(defaultMsg)
          .test(
            'locacao-associada-selecionado',
            defaultMsg,
            value =>
              !(associarLocacao === true && (value?.length <= 0 || !value)),
          ),
        base_address: Yup.string()
          .typeError(defaultMsg)
          .test(
            'base-apoio-selecionado',
            defaultMsg,
            value => !(baseApoio === true && (value?.length <= 0 || !value)),
          ),
        base_num: Yup.string()
          .typeError(defaultMsg)
          .test(
            'base-apoio-selecionado',
            defaultMsg,
            value => !(baseApoio === true && (value?.length <= 0 || !value)),
          ),
        tamanho_equipe_tecnica: Yup.string()
          .typeError(defaultMsg)
          .required(defaultMsg),
        tamanho_do_elenco: Yup.string()
          .typeError(defaultMsg)
          .required(defaultMsg),
        descricao_cena: Yup.string().typeError(defaultMsg).required(defaultMsg),
        descr_alto_impacto_local: Yup.string()
          .typeError(defaultMsg)
          .test(
            'alto-impacto-local-selecionado',
            defaultMsg,
            value =>
              !(
                showDescrAltoImpactoLocalField === true &&
                (value?.length <= 0 || !value)
              ),
          ),
        address_temp: Yup.string()
          .typeError(defaultMsg)
          .test(
            'local-filmagem-nao-selecionada',
            defaultMsg,
            value =>
              !(localFilmagem === false && (value?.length <= 0 || !value)),
          ),
        address: Yup.string()
          .typeError(defaultMsg)
          .test(
            'local-filmagem-selecionada',
            defaultMsg,
            value =>
              !(localFilmagem === true && (value?.length <= 0 || !value)),
          ),
        number: Yup.string()
          .typeError(defaultMsg)
          .test(
            'local-filmagem-selecionada',
            defaultMsg,
            value =>
              !(localFilmagem === true && (value?.length <= 0 || !value)),
          ),
        ld_complemento_numero_uuid: Yup.string()
          .typeError(defaultMsg)
          .test(
            'local-filmagem-selecionada',
            defaultMsg,
            value =>
              !(localFilmagem === true && (value?.length <= 0 || !value)),
          ),
        neighborhood: Yup.string().typeError(defaultMsg).required(defaultMsg),
        ld_tipo_interna_uuid: Yup.string()
          .typeError(defaultMsg)
          .test(
            'filmagem-interna-selecionada',
            defaultMsg,
            value => !(tipoFilmagem === true && (value?.length <= 0 || !value)),
          ),
        ld_tipo_externa_uuid: Yup.string()
          .typeError(defaultMsg)
          .test(
            'filmagem-externa-selecionada',
            defaultMsg,
            value =>
              !(tipoFilmagem === false && (value?.length <= 0 || !value)),
          ),
        estrutura_filmagem_interna: Yup.string()
          .typeError(defaultMsg)
          .test(
            'ocupacao-filmagem-interna-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === true &&
                selectedFilmagemInternaOpt?.startsWith('Ocupação') === true &&
                (!value || value?.length <= 0)
              ),
          ),
        dimensao_area_filmagem_interna: Yup.string()
          .typeError(defaultMsg)
          .test(
            'ocupacao-filmagem-interna-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === true &&
                selectedFilmagemInternaOpt?.startsWith('Ocupação') === true &&
                (!value || value?.length <= 0)
              ),
          ),
        extensao_ocupacao_faixa_interna: Yup.string()
          .typeError(defaultMsg)
          .test(
            'ocupacao-uma-faixa-filmagem-interna-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === true &&
                selectedFilmagemInternaOpt ===
                  'Ocupação de uma faixa junto ao meio fio para montagem de estrutura de apoio' &&
                (!value || value?.length <= 0)
              ),
          ),
        tipo_bloqueio_interna: Yup.string()
          .typeError(defaultMsg)
          .test(
            'bloqueio-intermitente-filmagem-interna-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === true &&
                selectedFilmagemInternaOpt?.startsWith(
                  'Bloqueio intermitente',
                ) &&
                (!value || value?.length <= 0)
              ),
          ),
        periodo_bloqueio_intermitente_interna: Yup.string()
          .typeError(defaultMsg)
          .test(
            'bloqueio-intermitente-filmagem-interna-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === true &&
                selectedFilmagemInternaOpt?.startsWith(
                  'Bloqueio intermitente',
                ) &&
                (!value || value?.length <= 0)
              ),
          ),
        numero_faixas_interna: Yup.string()
          .typeError(defaultMsg)
          .test(
            'bloqueio-intermitente-filmagem-interna-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === true &&
                selectedFilmagemInternaOpt?.startsWith(
                  'Bloqueio intermitente',
                ) &&
                tipoBloqueioAlgumasFaixas &&
                (!value || value?.length <= 0)
              ),
          ),
        inicio_horario_bloqueio_interna: Yup.string()
          .typeError(defaultMsg)
          .test(
            'bloqueio-total-filmagem-interna-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === true &&
                selectedFilmagemInternaOpt?.startsWith('Bloqueio total') &&
                (!value || value?.length <= 0)
              ),
          ),
        fim_horario_bloqueio_interna: Yup.string()
          .typeError(defaultMsg)
          .test(
            'bloqueio-total-filmagem-interna-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === true &&
                selectedFilmagemInternaOpt?.startsWith('Bloqueio total') &&
                (!value || value?.length <= 0)
              ),
          ),
        numero_faixas_bloqueadas_interna: Yup.string()
          .typeError(defaultMsg)
          .test(
            'bloqueio-total-alguma-faixa-filmagem-interna-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === true &&
                selectedFilmagemInternaOpt ===
                  'Bloqueio total de alguma(s) faixa(s) para captação de áudio ou para campo de câmera' &&
                (!value || value?.length <= 0)
              ),
          ),
        sentido_faixas_bloqueadas_interna: Yup.string()
          .typeError(defaultMsg)
          .test(
            'bloqueio-total-alguma-faixa-filmagem-interna-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === true &&
                selectedFilmagemInternaOpt ===
                  'Bloqueio total de alguma(s) faixa(s) para captação de áudio ou para campo de câmera' &&
                (!value || value?.length <= 0)
              ),
          ),
        ld_finalidade_bloqueio_uuid: Yup.string()
          .typeError(defaultMsg)
          .test(
            'bloqueio-total-via-filmagem-interna-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === true &&
                selectedFilmagemInternaOpt ===
                  'Bloqueio total de via para captação de áudio ou para campo de câmera' &&
                (!value || value?.length <= 0)
              ),
          ),
        estrutura_filmagem_externa: Yup.string()
          .typeError(defaultMsg)
          .test(
            'ocupacao-filmagem-externa-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === false &&
                selectedFilmagemExternaOpt?.startsWith('Ocupação') === true &&
                (!value || value?.length <= 0)
              ),
          ),
        dimensao_area_filmagem_externa: Yup.string()
          .typeError(defaultMsg)
          .test(
            'ocupacao-filmagem-externa-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === false &&
                selectedFilmagemExternaOpt?.startsWith('Ocupação') === true &&
                (!value || value?.length <= 0)
              ),
          ),
        tipo_bloqueio_externa: Yup.string()
          .typeError(defaultMsg)
          .test(
            'bloqueio-intermitente-filmagem-externa-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === false &&
                selectedFilmagemExternaOpt?.startsWith(
                  'Bloqueio intermitente',
                ) &&
                (!value || value?.length <= 0)
              ),
          ),
        periodo_bloqueio_intermitente_externa: Yup.string()
          .typeError(defaultMsg)
          .test(
            'bloqueio-intermitente-filmagem-externa-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === false &&
                selectedFilmagemExternaOpt?.startsWith(
                  'Bloqueio intermitente',
                ) &&
                (!value || value?.length <= 0)
              ),
          ),
        numero_faixas_externa: Yup.string()
          .typeError(defaultMsg)
          .test(
            'bloqueio-intermitente-filmagem-externa-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === false &&
                selectedFilmagemExternaOpt?.startsWith(
                  'Bloqueio intermitente',
                ) &&
                tipoBloqueioAlgumasFaixas &&
                (!value || value?.length <= 0)
              ),
          ),

        inicio_horario_bloqueio_externa: Yup.string()
          .typeError(defaultMsg)
          .test(
            'bloqueio-total-via-filmagem-externa-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === false &&
                selectedFilmagemExternaOpt?.startsWith(
                  'Bloqueio total da via',
                ) &&
                (!value || value?.length <= 0)
              ),
          ),
        fim_horario_bloqueio_externa: Yup.string()
          .typeError(defaultMsg)
          .test(
            'bloqueio-total-via-filmagem-externa-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === false &&
                selectedFilmagemExternaOpt?.startsWith(
                  'Bloqueio total da via',
                ) &&
                (!value || value?.length <= 0)
              ),
          ),
        inicio_numeracao_bloqueio_externa: Yup.string()
          .typeError(defaultMsg)
          .test(
            'bloqueio-total-via-filmagem-externa-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === false &&
                selectedFilmagemExternaOpt?.startsWith(
                  'Bloqueio total da via',
                ) &&
                (!value || value?.length <= 0)
              ),
          ),
        fim_numeracao_bloqueio_externa: Yup.string()
          .typeError(defaultMsg)
          .test(
            'bloqueio-total-via-filmagem-externa-selecionada',
            defaultMsg,
            value =>
              !(
                tipoFilmagem === false &&
                selectedFilmagemExternaOpt?.startsWith(
                  'Bloqueio total da via',
                ) &&
                (!value || value?.length <= 0)
              ),
          ),
        desc_intervencao_arte: Yup.string()
          .typeError(defaultMsg)
          .test(
            'intervencao-arte-selecionado',
            defaultMsg,
            value =>
              !(intervencaoArte === true && (value?.length <= 0 || !value)),
          ),
        ld_equipamento_filmagem: Yup.array()
          .of(Yup.string().typeError(defaultMsg).required(defaultMsg))
          .typeError(defaultMsg)
          .test(
            'ld-equipamento-filmagem-selecionado',
            defaultMsg,
            value => !(!value || value?.length <= 0),
          ),
        outro_equipamento: Yup.string()
          .typeError(defaultMsg)
          .test(
            'outro-equipamento-selecionado',
            defaultMsg,
            value =>
              !(
                showOutroEquipamentoField === true &&
                (value?.length <= 0 || !value)
              ),
          ),
        descricoes_equipamento_filmagem: Yup.string()
          .typeError(defaultMsg)
          .test(
            'descricoes-equipamento-filmagem-selecionado',
            defaultMsg,
            value =>
              !(
                showDescrEquipamentoFilmagemField === true &&
                (value?.length <= 0 || !value)
              ),
          ),
        ld_local_gerador_uuid: Yup.string()
          .typeError(defaultMsg)
          .test(
            'gerador-selecionado',
            defaultMsg,
            value => !(gerador === true && value?.length <= 0),
          ),
        ld_finalidade_base_apoio: Yup.array()
          .of(Yup.string().typeError(defaultMsg).required(defaultMsg))
          .typeError(defaultMsg)
          .test(
            'base-local-selecionado',
            defaultMsg,
            value => !(baseLocal === true && (value?.length <= 0 || !value)),
          ),
        outro_finalidade: Yup.string()
          .typeError(defaultMsg)
          .test(
            'outro-finalidade-selecionado',
            defaultMsg,
            value =>
              !(
                baseLocal &&
                showOutroFinalidadeField === true &&
                (value?.length <= 0 || !value)
              ),
          ),
        local_base_apoio: Yup.string()
          .typeError(defaultMsg)
          .test(
            'base-local-selecionado',
            defaultMsg,
            value => !(baseLocal === true && (value?.length <= 0 || !value)),
          ),
        ld_som_filmagem: Yup.array()
          .of(Yup.string().typeError(defaultMsg).required(defaultMsg))
          .typeError(defaultMsg)
          .test(
            'som-filmagem-selecionado',
            defaultMsg,
            value => !(somFilmagem === true && (value?.length <= 0 || !value)),
          ),
        descricoes_som_filmagem: Yup.string()
          .typeError(defaultMsg)
          .test(
            'descricoes-som-filmagem-selecionado',
            defaultMsg,
            value =>
              !(
                somFilmagem &&
                showDescrSomFilmagemField === true &&
                (value?.length <= 0 || !value)
              ),
          ),
        outro_som_filmagem: Yup.string()
          .typeError(defaultMsg)
          .test(
            'outro-som-filmagem-selecionado',
            defaultMsg,
            value =>
              !(
                somFilmagem &&
                showOutroSomFilmagemField === true &&
                (value?.length <= 0 || !value)
              ),
          ),
        ld_efeitos_especiais_uuid: Yup.string()
          .typeError(defaultMsg)
          .test(
            'ld-efeitos-especiais-selecionada',
            defaultMsg,
            value =>
              !(efeitosEspeciais === true && (!value || value.length <= 0)),
          ),
        estrutura_projecao: Yup.string()
          .typeError(defaultMsg)
          .test(
            'projecao-selecionado',
            defaultMsg,
            value => !(projecao === true && (value?.length <= 0 || !value)),
          ),
        instalacao_estrutura_projecao: Yup.string()
          .typeError(defaultMsg)
          .test(
            'projecao-selecionado',
            defaultMsg,
            value => !(projecao === true && (value?.length <= 0 || !value)),
          ),
        porcentagem_projecao: Yup.string()
          .typeError(defaultMsg)
          .test(
            'projecao-logo-selecionado',
            defaultMsg,
            value =>
              !(
                projecao &&
                projecaoLogo === true &&
                (value?.length <= 0 || !value)
              ),
          ),
        area_tempo_projeção: Yup.string()
          .typeError(defaultMsg)
          .test(
            'projecao-logo-selecionado',
            defaultMsg,
            value =>
              !(
                projecao &&
                projecaoLogo === true &&
                (value?.length <= 0 || !value)
              ),
          ),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      if (!validDateArray(datasFilmagemInputs, 'data_filmagem')) {
        await showModalMessage({
          type: 'error',
          text: 'Por favor, informe apenas datas válidas!',
        });
        return false;
      }

      if (!validHourArray(horasFilmagemInputs, 'inicio', 'fim')) {
        await showModalMessage({
          type: 'error',
          text: 'Por favor, informe apenas horas válidas!',
        });
        return false;
      }

      // Campos 'choice button' não selecionados
      if (associarLocacao === null) {
        await showModalMessage({
          type: 'error',
          text: 'Associar Locação não foi preenchido!',
        });
        setErrorsForm(state => ({
          ...state,
          associarLocacao: true,
        }));
        return false;
      }

      if (baseApoio === null) {
        await showModalMessage({
          type: 'error',
          text: 'Base de Apoio não foi preenchido!',
        });
        setErrorsForm(state => ({
          ...state,
          baseApoio: true,
        }));
        return false;
      }

      if (localFilmagem === null) {
        await showModalMessage({
          type: 'error',
          text: 'Local de filmagem não foi preenchido!',
        });
        setErrorsForm(state => ({
          ...state,
          localFilmagem: true,
        }));
        return false;
      }

      if (croquiFile === null) {
        await showModalMessage({
          type: 'error',
          text: 'Arquivo Croqui ainda não foi enviado!',
        });
        setErrorsForm(state => ({
          ...state,
          croquiFile: true,
        }));
        return false;
      }

      if (tipoFilmagem === null) {
        await showModalMessage({
          type: 'error',
          text: 'Tipo de Filmagem não foi preenchido!',
        });
        setErrorsForm(state => ({
          ...state,
          tipoFilmagem: true,
        }));
        return false;
      }

      if (tipoFilmagem === false && filmagemExternaEm === null) {
        await showModalMessage({
          type: 'error',
          text: '"Filmagem Em" não foi preenchido!',
        });
        setErrorsForm(state => ({
          ...state,
          filmagemExternaEm: true,
        }));
        return false;
      }

      if (intervencaoArte === null) {
        await showModalMessage({
          type: 'error',
          text: 'Intervenção de arte não foi informado!',
        });
        setErrorsForm(state => ({
          ...state,
          intervencaoArte: true,
        }));
        return false;
      }

      if (intervencaoArte === true && relatorioArteFile === null) {
        await showModalMessage({
          type: 'error',
          text: 'Arquivo Relatório Arte ainda não foi enviado!',
        });
        setErrorsForm(state => ({
          ...state,
          relatorioArteFile: true,
        }));
        return false;
      }

      if (gerador === null) {
        await showModalMessage({
          type: 'error',
          text: 'Gerador não foi preenchido!',
        });
        setErrorsForm(state => ({
          ...state,
          gerador: true,
        }));
        return false;
      }

      if (gerador === true && blimpado === null) {
        await showModalMessage({
          type: 'error',
          text: 'Campo blimpado não foi preenchido!',
        });
        setErrorsForm(state => ({
          ...state,
          blimpado: true,
        }));
        return false;
      }

      if (baseLocal === null) {
        await showModalMessage({
          type: 'error',
          text: 'Base de apoio não foi preenchido!',
        });
        setErrorsForm(state => ({
          ...state,
          baseLocal: true,
        }));
        return false;
      }

      if (captacaoSomDireto === null) {
        await showModalMessage({
          type: 'error',
          text: 'Captação de som direto não foi preenchido!',
        });
        setErrorsForm(state => ({
          ...state,
          captacaoSomDireto: true,
        }));
        return false;
      }

      if (somFilmagem === null) {
        await showModalMessage({
          type: 'error',
          text: 'Som na filmagem não foi preenchido!',
        });
        setErrorsForm(state => ({
          ...state,
          somFilmagem: true,
        }));
        return false;
      }

      if (drone === null) {
        await showModalMessage({
          type: 'error',
          text: 'Drone não foi preenchido!',
        });
        setErrorsForm(state => ({
          ...state,
          drone: true,
        }));
        return false;
      }

      if (efeitosEspeciais === null) {
        await showModalMessage({
          type: 'error',
          text: 'Efeitos especiais não foi preenchido!',
        });
        setErrorsForm(state => ({
          ...state,
          efeitosEspeciais: true,
        }));
        return false;
      }

      if (projecao === null) {
        await showModalMessage({
          type: 'error',
          text: 'Projeção de logradouro não foi preenchido!',
        });
        setErrorsForm(state => ({
          ...state,
          projecao: true,
        }));
        return false;
      }

      if (projecao) {
        if (conteudoProjecaoFile === null) {
          await showModalMessage({
            type: 'error',
            text: 'Arquivo Conteúdo da Projeção ainda não foi enviado!',
          });
          setErrorsForm(state => ({
            ...state,
            conteudoProjecaoFile: true,
          }));
          return false;
        }

        if (publicoPrivado === null) {
          await showModalMessage({
            type: 'error',
            text: 'Imóvel Público/Privado não foi informado!',
          });
          setErrorsForm(state => ({
            ...state,
            publicoPrivado: true,
          }));
          return false;
        }

        if (projecaoLogo === null) {
          await showModalMessage({
            type: 'error',
            text: 'Exibição de logomarca não foi informado!',
          });
          setErrorsForm(state => ({
            ...state,
            projecaoLogo: true,
          }));
          return false;
        }
      }

      if (desligarLuz === null) {
        await showModalMessage({
          type: 'error',
          text: 'Desligar luz não foi preenchido!',
        });
        setErrorsForm(state => ({
          ...state,
          desligarLuz: true,
        }));
        return false;
      }

      if (desligarLuz === true && iluminacaoFile === null) {
        await showModalMessage({
          type: 'error',
          text: 'Arquivo de projeção de logradouro ainda não foi enviado!',
        });
        setErrorsForm(state => ({
          ...state,
          iluminacaoFile: true,
        }));
        return false;
      }

      if (reservasVagas === null) {
        await showModalMessage({
          type: 'error',
          text: 'Reservas de Vagas não foi preenchido!',
        });
        setErrorsForm(state => ({
          ...state,
          reservasVagas: true,
        }));
        return false;
      }
    } catch (err) {
      await showModalMessage({
        type: 'error',
        text: 'Preencha os campos obrigatórios!',
      });
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
      }
      return false;
    }

    return true;
  }

  function formatDefaultData(data) {
    // dados já exibidos sem condicoes
    const dataNaoCondicional = omitEmpty({
      ld_impacto_uuid: data?.ld_impacto_uuid,
      tamanho_equipe_tecnica: data?.tamanho_equipe_tecnica,
      tamanho_do_elenco: data?.tamanho_do_elenco,
      descricao_cena: data?.descricao_cena,
      croqui_base64: data?.croqui_file,
      ld_equipamento_filmagem: data?.ld_equipamento_filmagem,
      especificidades: data?.especificidades,
    });

    // dados de choices
    const dataIntervencaoArte = intervencaoArte
      ? {
          desc_intervencao_arte: data?.desc_intervencao_arte,
          relat_arte_base64: data?.relatorio_arte_file,
        }
      : { desc_intervencao_arte: null, relat_arte_base64: null };

    const dataGerador = {
      blimpado: !gerador ? null : blimpado,
    };

    const dataBaseLocal = baseLocal
      ? {
          ld_finalidade_base_apoio: data?.ld_finalidade_base_apoio,
          local_base_apoio: data?.local_base_apoio,
          dimensao_base_apoio: data?.dimensao_base_apoio,
          quantidade_barracas: data?.quantidade_barracas,
        }
      : {
          ld_finalidade_base_apoio: null,
          local_base_apoio: null,
          dimensao_base_apoio: null,
          quantidade_barracas: null,
        };

    const dataCaptacaoSomDireto = { captação_som_direto: captacaoSomDireto };

    const dataSomFilmagem = {
      ld_som_filmagem: somFilmagem ? data?.ld_som_filmagem : null,
    };

    const dataDrone = { drone };

    const dataEfeitosEspeciais = {
      ld_efeitos_especiais_uuid: efeitosEspeciais
        ? data?.ld_efeitos_especiais_uuid
        : null,
    };

    const dataProjecao = projecao
      ? {
          estrutura_projecao: data?.estrutura_projecao,
          instalacao_estrutura_projecao: data?.instalacao_estrutura_projecao,
          imovel_publico_privado: publicoPrivado,
          projecao_base64: data?.conteudo_projecao_file,
        }
      : {
          estrutura_projecao: null,
          instalacao_estrutura_projecao: null,
          imovel_publico_privado: null,
          projecao_base64: null,
        };

    const dataProjecaoLogo =
      projecao && projecaoLogo
        ? {
            porcentagem_projecao: +data?.porcentagem_projecao || undefined,
            area_tempo_projeção: data?.area_tempo_projeção,
          }
        : { porcentagem_projecao: null, area_tempo_projeção: null };

    const dataIluminacao = {
      iluminacao_base64: desligarLuz ? data?.iluminacao_file : null,
    };

    // dados de campos exibidos condicionalmente
    const dataDescrAltoImpactoLocal = {
      descr_alto_impacto_local: showDescrAltoImpactoLocalField
        ? data?.descr_alto_impacto_local
        : null,
    };

    const dataDescrEquipamentoFilmagem = {
      descricoes_equipamento_filmagem: showDescrEquipamentoFilmagemField
        ? data?.descricoes_equipamento_filmagem
        : null,
    };

    const dataDescrSomFilmagem = {
      descricoes_som_filmagem:
        somFilmagem && showDescrSomFilmagemField
          ? data?.descricoes_som_filmagem
          : null,
    };

    const dataOutroEquipamento = {
      outro_equipamento: showOutroEquipamentoField
        ? data?.outro_equipamento
        : null,
    };

    const dataOutroFinalidade = {
      outro_finalidade:
        baseLocal && showOutroFinalidadeField ? data?.outro_finalidade : null,
    };

    const dataOutroSomFilmagem = {
      outro_som_filmagem:
        somFilmagem && showOutroSomFilmagemField
          ? data?.outro_som_filmagem
          : null,
    };

    // format datas filmagem
    const datasFilmagem = datasFilmagemInputs
      .filter(item => typeof item === 'object')
      .map(item => getBrowserTransformDate(item.data_filmagem));

    return Object.assign(
      dataNaoCondicional,
      { dates: datasFilmagem },
      { hours: horasFilmagemInputs },
      dataIntervencaoArte,
      dataGerador,
      dataBaseLocal,
      dataCaptacaoSomDireto,
      dataSomFilmagem,
      dataDrone,
      dataEfeitosEspeciais,
      dataProjecao,
      dataProjecaoLogo,
      dataIluminacao,
      dataDescrAltoImpactoLocal,
      dataDescrEquipamentoFilmagem,
      dataDescrSomFilmagem,
      dataOutroEquipamento,
      dataOutroFinalidade,
      dataOutroSomFilmagem,
    );
  }

  function formatEspecificaData(data) {
    const locacaoAssociada = utilizacaoAssociacaoList?.find(
      ({ uuid }) => uuid === data?.utilizacao_associacao?.uuid,
    );

    // dados já exibidos sem condicoes
    const dataNaoCondicional = omitEmpty({
      neighborhood: data?.neighborhood,
      titulo_locacao: data?.titulo_locacao,
    });

    // dados de choices
    const dataAssociarLocacao = associarLocacao
      ? {
          locacao: {
            reference_uuid: locacaoAssociada?.uuid,
            name_view: locacaoAssociada?.name_view,
          },
        }
      : { locacao: null };

    let dataBaseApoio = {};
    if (baseApoio) {
      const datasBaseEntrada = datasEntradaInputs
        ?.filter(item => typeof item === 'object')
        .map(item => ({
          date: getBrowserTransformDate(item.data_entrada),
          date_input: 'Entrada',
        }));

      const datasBaseSaida = datasSaidaInputs
        ?.filter(item => typeof item === 'object')
        .map(item => ({
          date: getBrowserTransformDate(item.data_saida),
          date_input: 'Saída',
        }));

      const horasBaseEntrada = horasEntradaInputs.map(item => ({
        ...item,
        hour_input: 'Entrada',
      }));
      const horasBaseSaida = horasSaidaInputs.map(item => ({
        ...item,
        hour_input: 'Saída',
      }));

      dataBaseApoio = {
        base_address: data?.base_address,
        base_num: data?.base_num,
        base_dates: [...datasBaseEntrada, ...datasBaseSaida],
        base_hours: [...horasBaseEntrada, ...horasBaseSaida],
      };
    }

    const dataLocalFilmagem = localFilmagem
      ? {
          address: data?.address,
          number: data?.number,
          ld_complemento_numero_uuid: data?.ld_complemento_numero_uuid,
          via_sentido: data?.via_sentido,
          address_temp: null,
        }
      : {
          address: null,
          number: null,
          ld_complemento_numero_uuid: null,
          via_sentido: null,
          address_temp: data?.address_temp,
        };

    const dataTipoFilmagem = tipoFilmagem
      ? {
          ld_tipo_interna_uuid: data?.ld_tipo_interna_uuid,
          ld_tipo_externa_uuid: null,
        }
      : {
          ld_tipo_interna_uuid: null,
          ld_tipo_externa_uuid: data?.ld_tipo_externa_uuid,
        };

    const dataFilmagemExternaEm = {
      filmagem_externa_em: tipoFilmagem !== false ? null : filmagemExternaEm,
    };

    /* Tipo Filmagem: Interna */

    // ocupação
    const dataFilmagemInternaOcupacao =
      tipoFilmagem === true &&
      selectedFilmagemInternaOpt?.startsWith('Ocupação') === true
        ? {
            estrutura_filmagem_interna: data?.estrutura_filmagem_interna,
            dimensao_area_filmagem_interna:
              +data?.dimensao_area_filmagem_interna || undefined,
          }
        : {
            estrutura_filmagem_interna: null,
            dimensao_area_filmagem_interna: null,
          };

    const dataFilmagemInternaOcupacaoFaixaJuntoMeioFioMontEstrutApoio =
      tipoFilmagem === true &&
      selectedFilmagemInternaOpt ===
        'Ocupação de uma faixa junto ao meio fio para montagem de estrutura de apoio'
        ? {
            extensao_ocupacao_faixa_interna:
              data?.extensao_ocupacao_faixa_interna,
          }
        : {
            extensao_ocupacao_faixa_interna: null,
          };

    // bloqueio
    const dataFilmagemInternaBloqueioIntermitente =
      tipoFilmagem === true &&
      selectedFilmagemInternaOpt?.startsWith('Bloqueio intermitente')
        ? {
            tipo_bloqueio_interna: data?.tipo_bloqueio_interna,
            periodo_bloqueio_intermitente_interna:
              data?.periodo_bloqueio_intermitente_interna,
            numero_faixas_interna: tipoBloqueioAlgumasFaixas
              ? data?.numero_faixas_interna
              : null,
          }
        : {
            tipo_bloqueio_interna: null,
            periodo_bloqueio_intermitente_interna: null,
            numero_faixas_interna: null,
          };

    const dataFilmagemInternaBloqueioTotal =
      selectedFilmagemInternaOpt?.startsWith('Bloqueio total') === true
        ? {
            inicio_horario_bloqueio_interna:
              data?.inicio_horario_bloqueio_interna,
            fim_horario_bloqueio_interna: data?.fim_horario_bloqueio_interna,
          }
        : {
            inicio_horario_bloqueio_interna: null,
            fim_horario_bloqueio_interna: null,
          };

    const dataFilmagemInternaBloqueioTotalAlgumaFaixa =
      tipoFilmagem === true &&
      selectedFilmagemInternaOpt ===
        'Bloqueio total de alguma(s) faixa(s) para captação de áudio ou para campo de câmera'
        ? {
            numero_faixas_bloqueadas_interna:
              data?.numero_faixas_bloqueadas_interna,
            sentido_faixas_bloqueadas_interna:
              data?.sentido_faixas_bloqueadas_interna,
          }
        : {
            numero_faixas_bloqueadas_interna: null,
            sentido_faixas_bloqueadas_interna: null,
          };

    const dataFilmagemInternaBloqueioTotalVia =
      tipoFilmagem === true &&
      selectedFilmagemInternaOpt ===
        'Bloqueio total de via para captação de áudio ou para campo de câmera'
        ? {
            ld_finalidade_bloqueio_uuid: data?.ld_finalidade_bloqueio_uuid,
          }
        : {
            ld_finalidade_bloqueio_uuid: null,
          };

    /* Tipo Filmagem: Externa */

    // ocupação
    const dataFilmagemExternaOcupacao =
      tipoFilmagem === false &&
      selectedFilmagemExternaOpt?.startsWith('Ocupação') === true
        ? {
            estrutura_filmagem_externa: data?.estrutura_filmagem_externa,
            dimensao_area_filmagem_externa:
              +data?.dimensao_area_filmagem_externa || undefined,
          }
        : {
            estrutura_filmagem_externa: null,
            dimensao_area_filmagem_externa: null,
          };

    // bloqueio
    const dataFilmagemExternaBloqueioIntermitente =
      tipoFilmagem === false &&
      selectedFilmagemExternaOpt?.startsWith('Bloqueio intermitente')
        ? {
            tipo_bloqueio_externa: data?.tipo_bloqueio_externa,
            periodo_bloqueio_intermitente_externa:
              data?.periodo_bloqueio_intermitente_externa,
            numero_faixas_externa: tipoBloqueioAlgumasFaixas
              ? data?.numero_faixas_externa
              : null,
          }
        : {
            tipo_bloqueio_externa: null,
            periodo_bloqueio_intermitente_externa: null,
            numero_faixas_externa: null,
          };

    const dataFilmagemExternaBloqueioTotalVia =
      tipoFilmagem === false &&
      selectedFilmagemExternaOpt?.startsWith('Bloqueio total da via')
        ? {
            inicio_horario_bloqueio_externa:
              data?.inicio_horario_bloqueio_externa,
            fim_horario_bloqueio_externa: data?.fim_horario_bloqueio_externa,
            inicio_numeracao_bloqueio_externa:
              data?.inicio_numeracao_bloqueio_externa,
            fim_numeracao_bloqueio_externa:
              data?.fim_numeracao_bloqueio_externa,
          }
        : {
            inicio_horario_bloqueio_externa: null,
            fim_horario_bloqueio_externa: null,
            inicio_numeracao_bloqueio_externa: null,
            fim_numeracao_bloqueio_externa: null,
          };

    const dataGerador = {
      ld_local_gerador_uuid: !gerador ? null : data?.ld_local_gerador_uuid,
    };

    return Object.assign(
      dataNaoCondicional,
      dataAssociarLocacao,
      dataBaseApoio,
      dataLocalFilmagem,
      dataGerador,
      dataTipoFilmagem,
      dataFilmagemExternaEm,
      dataFilmagemInternaOcupacao,
      dataFilmagemInternaOcupacaoFaixaJuntoMeioFioMontEstrutApoio,
      dataFilmagemInternaBloqueioIntermitente,
      dataFilmagemInternaBloqueioTotal,
      dataFilmagemInternaBloqueioTotalAlgumaFaixa,
      dataFilmagemInternaBloqueioTotalVia,
      dataFilmagemExternaOcupacao,
      dataFilmagemExternaBloqueioIntermitente,
      dataFilmagemExternaBloqueioTotalVia,
    );
  }

  async function handleSubmit(data) {
    // files
    data.croqui_file = formData?.croqui_file;
    data.relatorio_arte_file = formData?.relatorio_arte_file;
    data.conteudo_projecao_file = formData?.conteudo_projecao_file;
    data.iluminacao_file = formData?.iluminacao_file;

    // selects
    data.ld_equipamento_filmagem = formData?.ld_equipamento_filmagem;
    data.ld_finalidade_base_apoio = formData?.ld_finalidade_base_apoio;
    data.ld_som_filmagem = formData?.ld_som_filmagem;

    if (!(await handleValidationFields(data))) {
      return;
    }

    try {
      const defaultData = formatDefaultData(data);
      const especificaData = formatEspecificaData(data);

      window.console.log(especificaData);

      // if (data || !data) {
      //   return;
      // }

      setLoading(true);

      const responseDefault = await ApiClient.doRequest({
        uri: 'locacao-default',
        method: ApiClient.POST,
        body: defaultData,
        expectedStatus: 201,
      });

      await ApiClient.doRequest({
        uri: 'locacao-utilizacao-via',
        method: ApiClient.POST,
        body: Object.assign(
          especificaData,
          { work_uuid: dadoState?.uuid },
          { locacao_default_uuid: responseDefault?.data?.data?.uuid },
        ),
        expectedStatus: 201,
      });

      setLoading(false);

      await showModalMessage({
        type: 'success',
        title:
          'Filmagens (ou apoio) em Filmagens (ou apoio) em ruas/calçadas/vias/viadutos/passarelas/túneis/correlatos',
        text: 'Locação gravada com sucesso',
      });

      // conclusao
      const urlReservas = '/solicitacao-nova-locacao/reservas-vagas-vinculado';
      const hasReservas = dadoState?.redirections?.some(
        ({ url }) => url === urlReservas,
      );

      const redirections = [
        ...(dadoState?.redirections || []),
        { url: urlReservas, next: hasReservas || reservasVagas },
      ].filter(({ next }) => !!next);

      const [nextRedirect] = redirections;

      if (nextRedirect) {
        history.replace({
          pathname: nextRedirect.url,
          state: {
            uuid: dadoState?.uuid,
            redirections: redirections.filter(
              ({ url }) => url !== nextRedirect.url,
            ),
          },
        });
      } else {
        history.push('/home-user');
      }
    } catch (err) {
      setLoading(false);
      await showModalMessage({
        type: 'success',
        title:
          'Filmagens (ou apoio) em Filmagens (ou apoio) em ruas/calçadas/vias/viadutos/passarelas/túneis/correlatos',
        text: 'Ocorreu um erro ao tentar gravar Filmagens (ou apoio) em ruas/calçadas/vias/viadutos/passarelas/túneis/correlatos. Verifique os dados.',
      });

      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
      }
    }
  }

  function renderLocacao() {
    if (dadoState?.viewData && !loading && !responseLocation) {
      return (
        <PageContainer style={{ height: '100%' }}>
          <PageContent>
            <WhiteBox column jCenter aCenter marginBottom="30px">
              <h3 style={{ color: '#828282' }}>Nenhuma Locação encontrada</h3>
            </WhiteBox>
          </PageContent>
        </PageContainer>
      );
    }

    return (
      <>
        {loading && (
          <MainLoading loading={loading}>
            <h3>Processando Informações</h3>
            <BiLoaderAlt size={32} color="#ffffff" className="icon-spin" />
          </MainLoading>
        )}
        <PageContainer>
          <PageContent>
            <Form ref={formRef} onSubmit={handleSubmit}>
              <WhiteBox column jCenter aCenter marginBottom="30px">
                {!isAdminRequest && (
                  <>
                    <LocacaoDocs
                      excludes={['precosFilmagensEquipamentosPublicos']}
                    />
                  </>
                )}

                <BoxHeader>
                  <span className="boxText">Informações gerais</span>
                </BoxHeader>
                <Wrap>
                  <Textarea
                    name="form_info"
                    rows="3"
                    value='Caso a produção precise utilizar mais de uma via para a mesma locação (Ex.: Trajeto;
                      Filmagens em esquinas; Filmagens em uma via com apoio em outra via próxima), deverá especificar no
                      campo "Endereço". Só serão enviados para a análise dos órgãos os pedidos enviados com todas as informações
                      obrigatórias solicitadas.'
                    disabled
                  />
                </Wrap>

                {responseLocation?.protocol && (
                  <BoxHeader>
                    <span
                      className="boxText"
                      style={{ color: '#828282' }}
                    >{`[ Número: ${responseLocation?.protocol} ]`}</span>
                  </BoxHeader>
                )}

                <Wrap>
                  <LimiterInputWidth w50>
                    <Input
                      type="text"
                      name="titulo_locacao"
                      label="Nome da Locação (Opcional)"
                      onChange={handleChange}
                      defaultValue={
                        dadoState?.viewData && responseLocation?.titulo_locacao
                      }
                      disabled={dadoState?.viewData && true}
                      questionTooltip="Para controle interno das produções, é possível adicionar o nome da locação, como por exemplo: Casa da Personagem Principal. Esse controle não constará em pedidos e documentações oficiais, e é somente um facilitador em projetos de grande porte."
                    />
                  </LimiterInputWidth>
                  <LimiterInputWidth w50>
                    <Select
                      name="ld_impacto_uuid"
                      label="Você classifica sua filmagem como sendo:"
                      placeholder="Selecione"
                      options={impactoSelectList}
                      style={selectCustomStyles}
                      onChange={value => {
                        handleSelectChange('ld_impacto_uuid', value);
                        setShowDescrAltoImpactoLocalField(
                          value.label === 'alto impacto no local',
                        );
                      }}
                      required
                      questionTooltip="Clique aqui para saber mais"
                      questionOnClick={() => setOpenModalPorteFilmagem(true)}
                      isDisabled={dadoState?.viewData && true}
                    />
                  </LimiterInputWidth>
                </Wrap>
                <ConditionalContainer show={showDescrAltoImpactoLocalField}>
                  <Wrap>
                    <Textarea
                      type="text"
                      name="descr_alto_impacto_local"
                      label="Comente qual o desafio da sua produção para auxiliarmos em sua viabilização"
                      onChange={handleChange}
                      required
                      rows="3"
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.locacao_default
                          ?.descr_alto_impacto_local
                      }
                      disabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Deseja associa-lá com uma Locação cadastrada?"
                      onClickTrue={handleAssociarLocacaoTrue}
                      onClickFalse={handleAssociarLocacaoFalse}
                      selected={associarLocacao}
                      error={
                        errorsForm.associarLocacao === true && 'Obrigatório'
                      }
                      isDisabled={dadoState?.viewData && true}
                      required
                    />
                  </LimiterInputWidth>
                </Wrap>

                <ConditionalContainer show={associarLocacao}>
                  <LimiterInputWidth w50>
                    <Select
                      name="utilizacao_associacao"
                      label="Escolha a Locação a ser associada:"
                      placeholder="Selecione"
                      options={utilizacaoAssociacaoList?.map(
                        ({ uuid, name_view, protocol, endpoint }) => ({
                          label: `${name_view} - ${protocol}`,
                          value: { uuid, endpoint },
                        }),
                      )}
                      style={selectCustomStyles}
                      onChange={value => {
                        handleSelectChange('utilizacao_associacao', value);
                      }}
                      required
                      isDisabled={dadoState?.viewData && true}
                    />
                  </LimiterInputWidth>

                  {Object.values(formData?.utilizacao_associacao || {}).length >
                    0 && (
                    <Wrap>
                      <FormChoiceButton
                        nomeProjeto={dadoState?.nome_projeto}
                        viewData={{
                          is_admin: isAdminRequest,
                          uuid: formData?.utilizacao_associacao?.uuid,
                          endpoint: formData?.utilizacao_associacao?.endpoint,
                        }}
                      />
                    </Wrap>
                  )}
                </ConditionalContainer>
                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Já possui local definido para a base de apoio?"
                      onClickTrue={handleBaseApoioTrue}
                      onClickFalse={handleBaseApoioFalse}
                      selected={baseApoio}
                      required
                      isDisabled={dadoState?.viewData && true}
                      error={errorsForm.baseApoio === true && 'Obrigatório'}
                    />
                  </LimiterInputWidth>
                </Wrap>

                <ConditionalContainer show={baseApoio}>
                  <Wrap>
                    <LimiterInputWidth w50>
                      <Input
                        type="text"
                        name="base_address"
                        label="Endereço"
                        onChange={handleChange}
                        defaultValue={
                          dadoState?.viewData && responseLocation?.base_address
                        }
                        required={baseApoio}
                        disabled={dadoState?.viewData}
                      />
                    </LimiterInputWidth>
                    <LimiterInputWidth w25>
                      <Input
                        type="text"
                        name="base_num"
                        label="Número"
                        onChange={handleChange}
                        maxLength={11}
                        required={baseApoio}
                        defaultValue={
                          dadoState?.viewData && responseLocation?.base_num
                        }
                        disabled={dadoState?.viewData}
                      />
                    </LimiterInputWidth>
                  </Wrap>

                  <BoxHeader>
                    <span className="boxText">Entrada da Base</span>
                  </BoxHeader>
                  <Wrap>
                    <DateFormMultiInput
                      label="Data da Reserva"
                      dates={datasEntradaInputs}
                      setDates={setDatasEntradaInputs}
                      isViewMode={dadoState?.viewData}
                      dateKeyName="data_entrada"
                      tooltip="Possível adicionar mais de uma data"
                      isRequired={baseApoio}
                    />

                    <HourFormMultiInput
                      label="Hora da Entrada (Início e Fim)"
                      hours={horasEntradaInputs}
                      setHours={setHorasEntradaInputs}
                      isViewMode={dadoState?.viewData}
                      hourBeginKeyName="inicio"
                      hourEndKeyName="fim"
                      tooltip="Informar a hora de inicio e fim da entrada."
                      isRequired={baseApoio}
                    />
                  </Wrap>

                  <BoxHeader>
                    <span className="boxText">Saída da Base</span>
                  </BoxHeader>
                  <Wrap>
                    <DateFormMultiInput
                      label="Data da Reserva"
                      dates={datasSaidaInputs}
                      setDates={setDatasSaidaInputs}
                      isViewMode={dadoState?.viewData}
                      dateKeyName="data_saida"
                      tooltip="Possível adicionar mais de uma data"
                      isRequired={baseApoio}
                    />

                    <HourFormMultiInput
                      label="Hora da Entrada (Início e Fim)"
                      hours={horasSaidaInputs}
                      setHours={setHorasSaidaInputs}
                      isViewMode={dadoState?.viewData}
                      hourBeginKeyName="inicio"
                      hourEndKeyName="fim"
                      tooltip="Informar a hora de inicio e fim da saída."
                      isRequired={baseApoio}
                    />
                  </Wrap>
                </ConditionalContainer>
                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Já possui a definição de local exato da solicitação de filmagem/apoio?"
                      onClickTrue={handleLocalFilmagemTrue}
                      onClickFalse={handleLocalFilmagemFalse}
                      selected={localFilmagem}
                      error={errorsForm.localFilmagem === true && 'Obrigatório'}
                      isDisabled={dadoState?.viewData && true}
                      required
                    />
                  </LimiterInputWidth>
                </Wrap>
                <ConditionalContainer show={localFilmagem === false}>
                  <Wrap>
                    <Input
                      type="text"
                      name="address_temp"
                      label="Endereço previsto"
                      onChange={handleChange}
                      required
                      defaultValue={
                        dadoState?.viewData && responseLocation?.address_temp
                      }
                      disabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                </ConditionalContainer>
                <ConditionalContainer show={localFilmagem === true}>
                  <>
                    <Wrap>
                      <Input
                        type="text"
                        name="address"
                        label="Endereço"
                        onChange={handleChange}
                        required
                        defaultValue={
                          dadoState?.viewData && responseLocation?.address
                        }
                        disabled={dadoState?.viewData && true}
                      />
                      <Input
                        type="number"
                        name="number"
                        label="Número"
                        onChange={handleChange}
                        required
                        defaultValue={
                          dadoState?.viewData && responseLocation?.number
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </Wrap>
                    <Wrap>
                      <Select
                        name="ld_complemento_numero_uuid"
                        label="Opções"
                        placeholder="Selecione"
                        options={complementoNumeroSelectList}
                        style={selectCustomStyles}
                        onChange={value => {
                          handleSelectChange(
                            'ld_complemento_numero_uuid',
                            value,
                          );
                        }}
                        required
                        isDisabled={dadoState?.viewData && true}
                      />
                      <Input
                        type="text"
                        name="via_sentido"
                        label="Caso a via possua mais de um sentido, especificar qual:"
                        onChange={handleChange}
                        defaultValue={
                          dadoState?.viewData && responseLocation?.via_sentido
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </Wrap>
                  </>
                </ConditionalContainer>
                <Wrap>
                  <LimiterInputWidth w50>
                    <Input
                      type="text"
                      name="neighborhood"
                      label="Bairro"
                      onChange={handleChange}
                      required
                      defaultValue={
                        dadoState?.viewData && responseLocation?.neighborhood
                      }
                      disabled={dadoState?.viewData && true}
                    />
                  </LimiterInputWidth>
                </Wrap>
                <Wrap>
                  <DateFormMultiInput
                    label="Data(s)"
                    dates={datasFilmagemInputs}
                    setDates={setDatasFilmagemInputs}
                    setIsLoading={setLoading}
                    isViewMode={dadoState?.viewData}
                    dateKeyName="data_filmagem"
                    isAdminRequest={isAdminRequest}
                    tooltip="Possível adicionar mais de uma data"
                    isRequired
                  />

                  <HourFormMultiInput
                    label="Horário(s)"
                    hours={horasFilmagemInputs}
                    setHours={setHorasFilmagemInputs}
                    setIsLoading={setLoading}
                    isViewMode={dadoState?.viewData}
                    hourBeginKeyName="inicio"
                    hourEndKeyName="fim"
                    tooltip="Possível adicionar mais de um período"
                    isAdminRequest={isAdminRequest}
                    isRequired
                  />
                </Wrap>

                <Wrap>
                  <Input
                    type="number"
                    name="tamanho_equipe_tecnica"
                    label="Tamanho da Equipe Técnica"
                    onChange={handleChange}
                    required
                    defaultValue={
                      dadoState?.viewData &&
                      responseLocation?.locacao_default?.tamanho_equipe_tecnica
                    }
                    disabled={dadoState?.viewData && true}
                  />
                  <Input
                    type="number"
                    name="tamanho_do_elenco"
                    label="Tamanho do elenco"
                    onChange={handleChange}
                    required
                    defaultValue={
                      dadoState?.viewData &&
                      responseLocation?.locacao_default?.tamanho_do_elenco
                    }
                    disabled={dadoState?.viewData && true}
                  />
                </Wrap>
                <Wrap>
                  <Textarea
                    type="text"
                    name="descricao_cena"
                    label="Descrição da Cena"
                    onChange={handleChange}
                    rows="3"
                    required
                    defaultValue={
                      dadoState?.viewData &&
                      responseLocation?.locacao_default?.descricao_cena
                    }
                    disabled={dadoState?.viewData && true}
                  />
                </Wrap>

                <Wrap>
                  <File
                    label="Croqui da Intervenção"
                    attach={dataCroquiFile}
                    textFile="Nenhum arquivo selecionado"
                    name="croqui_file"
                    required
                    inputRef={croquiFileRef}
                    onChange={handleFileChange}
                    onClick={handleCroquiFile}
                    error={errorsForm.croquiFile === true && 'Obrigatório, tamanho máximo 20MB'}
                    link={fileCroqui?.length > 0 && fileCroqui[0].url}
                    isDisabled={dadoState?.viewData && true}
                  />
                </Wrap>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Tipo de filmagem:"
                      onClickTrue={handleTipoFilmagemTrue}
                      onClickFalse={handleTipoFilmagemFalse}
                      selected={tipoFilmagem}
                      required
                      isDisabled={dadoState?.viewData && true}
                      error={errorsForm.tipoFilmagem === true && 'Obrigatório'}
                      yesLabelValue="Interna"
                      noLabelValue="Externa"
                    />
                  </LimiterInputWidth>

                  <ConditionalContainer show={tipoFilmagem === true}>
                    <Select
                      name="ld_tipo_interna_uuid"
                      label="Ocupação desejada"
                      placeholder="Selecione"
                      options={filmagemInternaOpts}
                      style={selectCustomStyles}
                      onChange={value => {
                        handleSelectFilmagem('ld_tipo_interna_uuid', value);
                      }}
                      required
                      isDisabled={dadoState?.viewData && true}
                    />
                  </ConditionalContainer>

                  <ConditionalContainer
                    show={tipoFilmagem === false}
                    style={{ flexDirection: 'row' }}
                  >
                    <LimiterInputWidth w50>
                      <ChoiceButtonLocacao
                        label="Filmagem em:"
                        onClickTrue={handleFilmagemExternaEmTrue}
                        onClickFalse={handleFilmagemExternaEmFalse}
                        selected={filmagemExternaEm}
                        required
                        isDisabled={dadoState?.viewData && true}
                        error={
                          errorsForm.filmagemExternaEm === true && 'Obrigatório'
                        }
                        yesLabelValue="Ponto Fixo"
                        noLabelValue="Trajeto"
                      />
                    </LimiterInputWidth>

                    <Select
                      name="ld_tipo_externa_uuid"
                      label="Ocupação desejada"
                      placeholder="Selecione"
                      options={filmagemExternaOpts}
                      style={selectCustomStyles}
                      onChange={value => {
                        handleSelectFilmagem('ld_tipo_externa_uuid', value);
                      }}
                      required
                      isDisabled={dadoState?.viewData && true}
                    />
                  </ConditionalContainer>
                </Wrap>

                {/* Interna Opts Ocupação */}
                <ConditionalContainer
                  show={
                    tipoFilmagem === true &&
                    selectedFilmagemInternaOpt?.startsWith('Ocupação') === true
                  }
                >
                  {/* OPT 2 */}
                  {selectedFilmagemInternaOpt ===
                    'Ocupação total do passeio (calçada) para montagem de estruturas de apoio' && (
                    <Wrap>
                      <Textarea
                        name="interna-opt2-info"
                        rows={3}
                        defaultValue="Em casos de bloqueio total da calçada é obrigatória a canalização dos
                        pedestres. Caso seja em local de estacionamento permitido, a produção deve solicitar
                        uma reserva de vagas, e caso não seja, a SPFilm avaliará junto à CET sobre as possíveis
                        opções de canalização que a produção poderá operacionalizar."
                        disabled
                      />
                    </Wrap>
                  )}

                  {/* OPT 3 */}
                  {selectedFilmagemInternaOpt ===
                    'Ocupação de uma faixa junto ao meio fio para montagem de estrutura de apoio' && (
                    <Wrap>
                      <Textarea
                        name="interna-opt3-info"
                        rows={4}
                        defaultValue="Caso a ocupação da faixa seja em local de estacionamento permitido, a
                        produção deve solicitar uma reserva de vagas iniciando em horário anterior ao da
                        ocupação da faixa para garantir que estará livre no momento da montagem do apoio;
                        caso seja em local de estacionamento proibido, a SPFilm avaliará junto à CET sobre as
                        possíveis opções de canalização que a produção poderá operacionalizar."
                        disabled
                      />
                    </Wrap>
                  )}

                  <Wrap>
                    <Textarea
                      type="text"
                      name="estrutura_filmagem_interna"
                      label="Qual a estrutura que será montada"
                      onChange={handleChange}
                      required
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.estrutura_filmagem_interna
                      }
                      disabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                  <Wrap style={{ alignItems: 'flex-end' }}>
                    <LimiterInputWidth w50>
                      <Input
                        type="number"
                        step="0.01"
                        name="dimensao_area_filmagem_interna"
                        label="Qual a dimensão (extensão ou área) aproximada da área ocupada:"
                        onChange={handleChange}
                        required
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.dimensao_area_filmagem_interna
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </LimiterInputWidth>

                    {/* OPT 3 */}
                    <ConditionalContainer
                      show={
                        selectedFilmagemInternaOpt ===
                        'Ocupação de uma faixa junto ao meio fio para montagem de estrutura de apoio'
                      }
                    >
                      <LimiterInputWidth>
                        <Input
                          type="number"
                          step="0.01"
                          name="extensao_ocupacao_faixa_interna"
                          label="Extensão da ocupação"
                          onChange={handleChange}
                          required
                          defaultValue={
                            dadoState?.viewData &&
                            responseLocation?.extensao_ocupacao_faixa_interna
                          }
                          disabled={dadoState?.viewData && true}
                        />
                      </LimiterInputWidth>
                    </ConditionalContainer>
                  </Wrap>
                </ConditionalContainer>

                {/* Interna Opts Bloqueio */}
                <ConditionalContainer
                  show={
                    tipoFilmagem === true &&
                    selectedFilmagemInternaOpt?.startsWith('Bloqueio') === true
                  }
                >
                  {/* OPT 4 */}
                  <ConditionalContainer
                    show={
                      selectedFilmagemInternaOpt ===
                      'Bloqueio intermitente da via para captação de áudio ou para campo de câmera'
                    }
                  >
                    <Wrap>
                      <Select
                        name="tipo_bloqueio_interna"
                        label="Tipo de bloqueio"
                        placeholder="Selecione"
                        options={optionsTipoBloqueio}
                        style={selectCustomStyles}
                        onChange={value => {
                          handleSelectChange('tipo_bloqueio_interna', value);
                          setTipoBloqueioAlgumasFaixas(
                            value.value === 'algumas_faixas',
                          );
                        }}
                        required
                        isDisabled={dadoState?.viewData && true}
                      />

                      <ConditionalContainer
                        show={tipoBloqueioAlgumasFaixas === true}
                        style={{ marginRight: 15 }}
                      >
                        <Input
                          type="number"
                          name="numero_faixas_interna"
                          label="Número de faixas"
                          onChange={handleChange}
                          required
                          defaultValue={
                            dadoState?.viewData &&
                            responseLocation?.numero_faixas_interna
                          }
                          disabled={dadoState?.viewData && true}
                        />
                      </ConditionalContainer>

                      <Input
                        type="number"
                        name="periodo_bloqueio_intermitente_interna"
                        label="Período de bloqueio intermitente"
                        onChange={handleChange}
                        required
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.periodo_bloqueio_intermitente_interna
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </Wrap>
                  </ConditionalContainer>

                  {/* OPT 5 */}
                  <ConditionalContainer
                    show={
                      selectedFilmagemInternaOpt ===
                      'Bloqueio total de alguma(s) faixa(s) para captação de áudio ou para campo de câmera'
                    }
                  >
                    <Wrap>
                      <Input
                        type="number"
                        name="numero_faixas_bloqueadas_interna"
                        label="Número de faixas bloqueadas"
                        onChange={handleChange}
                        required
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.numero_faixas_bloqueadas_interna
                        }
                        disabled={dadoState?.viewData && true}
                      />

                      <Input
                        name="sentido_faixas_bloqueadas_interna"
                        label="Sentido das faixas bloqueadas"
                        onChange={handleChange}
                        required
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.sentido_faixas_bloqueadas_interna
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </Wrap>
                  </ConditionalContainer>

                  {/* OPT 6 */}
                  <ConditionalContainer
                    show={
                      selectedFilmagemInternaOpt ===
                      'Bloqueio total de via para captação de áudio ou para campo de câmera'
                    }
                  >
                    <Wrap>
                      <Select
                        name="ld_finalidade_bloqueio_uuid"
                        label="Finalidade de bloqueio"
                        placeholder="Selecione"
                        options={finalidadeBloqueioOpts}
                        style={selectCustomStyles}
                        onChange={value => {
                          handleSelectFinalidadeBloqueio(
                            'ld_finalidade_bloqueio_uuid',
                            value,
                          );
                        }}
                        required
                        isDisabled={dadoState?.viewData && true}
                      />
                    </Wrap>
                  </ConditionalContainer>

                  {/* OPTs Não Bloqueio intermitente */}
                  <ConditionalContainer
                    show={
                      selectedFilmagemInternaOpt?.startsWith(
                        'Bloqueio total',
                      ) === true
                    }
                  >
                    <Wrap className="label">
                      <BoxHeader>
                        <span className="boxText">
                          Horário exato do bloqueio
                        </span>
                      </BoxHeader>
                      <Wrap>
                        <LimiterInputWidth w25>
                          <Input
                            type="time"
                            name="inicio_horario_bloqueio_interna"
                            label="Das"
                            onChange={handleChange}
                            required
                            defaultValue={
                              dadoState?.viewData &&
                              responseLocation?.inicio_horario_bloqueio_interna
                            }
                            disabled={dadoState?.viewData && true}
                          />
                        </LimiterInputWidth>
                        <LimiterInputWidth w25>
                          <Input
                            type="time"
                            name="fim_horario_bloqueio_interna"
                            label="Às"
                            onChange={handleChange}
                            required
                            defaultValue={
                              dadoState?.viewData &&
                              responseLocation?.fim_horario_bloqueio_interna
                            }
                            disabled={dadoState?.viewData && true}
                          />
                        </LimiterInputWidth>
                      </Wrap>
                    </Wrap>
                  </ConditionalContainer>
                </ConditionalContainer>

                {/* Externa Opts Ocupação */}
                <ConditionalContainer
                  show={
                    tipoFilmagem === false &&
                    selectedFilmagemExternaOpt?.startsWith('Ocupação') === true
                  }
                >
                  {/* OPT 2 */}
                  {selectedFilmagemExternaOpt ===
                    'Ocupação total do passeio (calçada) para cena' && (
                    <Wrap>
                      <Textarea
                        name="externa-opt2-info"
                        rows="3"
                        defaultValue="Em casos de bloqueio total da calçada é obrigatória a canalização dos
                      pedestres. Caso seja em local de estacionamento permitido, a produção deve solicitar
                      uma reserva de vagas, e caso não seja, a SPFilm avaliará junto à CET sobre as possíveis
                      opções de canalização que a produção poderá operacionalizar."
                        disabled
                      />
                    </Wrap>
                  )}

                  {/* OPT 3 */}
                  {selectedFilmagemExternaOpt ===
                    'Ocupação de faixa(s) junto ao meio fio para cena' && (
                    <Wrap>
                      <Textarea
                        name="externa-opt3-info"
                        rows="4"
                        defaultValue="Caso a ocupação da faixa seja em local de estacionamento permitido, a
                      produção deve solicitar uma reserva de vagas iniciando em horário anterior ao da
                      ocupação da faixa para garantir que estará livre no momento da montagem do apoio;
                      caso seja em local de estacionamento proibido, a SPFilm avaliará junto à CET sobre as
                      possíveis opções de canalização que a produção poderá operacionalizar."
                        disabled
                      />
                    </Wrap>
                  )}

                  <Wrap>
                    <Textarea
                      type="text"
                      name="estrutura_filmagem_externa"
                      label="Qual a estrutura que será montada"
                      onChange={handleChange}
                      required
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.estrutura_filmagem_externa
                      }
                      disabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                  <Wrap style={{ alignItems: 'flex-end' }}>
                    <LimiterInputWidth w50>
                      <Input
                        type="number"
                        step="0.01"
                        name="dimensao_area_filmagem_externa"
                        label="Qual a dimensão (extensão ou área) da estrutura"
                        onChange={handleChange}
                        required
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.dimensao_area_filmagem_externa
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </LimiterInputWidth>
                  </Wrap>
                </ConditionalContainer>

                {/* Externa Opts Bloqueio */}
                <ConditionalContainer
                  show={
                    tipoFilmagem === false &&
                    selectedFilmagemExternaOpt?.startsWith('Bloqueio') === true
                  }
                >
                  {/* OPT 4 */}
                  <ConditionalContainer
                    show={
                      selectedFilmagemExternaOpt ===
                      'Bloqueio intermitente de faixa(s) da via para cena'
                    }
                  >
                    <Wrap>
                      <Select
                        name="tipo_bloqueio_externa"
                        label="Tipo de bloqueio"
                        placeholder="Selecione"
                        options={optionsTipoBloqueio}
                        style={selectCustomStyles}
                        onChange={value => {
                          handleSelectChange('tipo_bloqueio_externa', value);
                          setTipoBloqueioAlgumasFaixas(
                            value.value === 'algumas_faixas',
                          );
                        }}
                        required
                        isDisabled={dadoState?.viewData && true}
                      />

                      <ConditionalContainer
                        show={tipoBloqueioAlgumasFaixas === true}
                        style={{ marginRight: 15 }}
                      >
                        <Input
                          type="number"
                          name="numero_faixas_externa"
                          label="Números de faixas"
                          onChange={handleChange}
                          required
                          defaultValue={
                            dadoState?.viewData &&
                            responseLocation?.numero_faixas_externa
                          }
                          disabled={dadoState?.viewData && true}
                        />
                      </ConditionalContainer>
                      <Input
                        type="number"
                        name="periodo_bloqueio_intermitente_externa"
                        label="Período de bloqueio intermitente"
                        onChange={handleChange}
                        required
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.periodo_bloqueio_intermitente_externa
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </Wrap>
                  </ConditionalContainer>

                  {/* OPT 5 */}
                  <ConditionalContainer
                    show={
                      selectedFilmagemExternaOpt ===
                      'Bloqueio total da via para cena'
                    }
                  >
                    <Wrap>
                      <Textarea
                        name="externa-opt5-info"
                        rows={1}
                        defaultValue="Em casos de bloqueio total da via pode ser solicitado a confecção de faixa de aviso
                        para instalação na via."
                        disabled
                      />
                    </Wrap>
                    <Wrap>
                      <Wrap className="label">
                        <BoxHeader>
                          <span className="boxText">
                            Horário exato do bloqueio
                          </span>
                        </BoxHeader>
                        <Wrap>
                          <Input
                            type="time"
                            name="inicio_horario_bloqueio_externa"
                            label="Das"
                            onChange={handleChange}
                            required
                            defaultValue={
                              dadoState?.viewData &&
                              responseLocation?.inicio_horario_bloqueio_externa
                            }
                            disabled={dadoState?.viewData && true}
                          />
                          <Input
                            type="time"
                            name="fim_horario_bloqueio_externa"
                            label="Às"
                            onChange={handleChange}
                            required
                            defaultValue={
                              dadoState?.viewData &&
                              responseLocation?.fim_horario_bloqueio_externa
                            }
                            disabled={dadoState?.viewData && true}
                          />
                        </Wrap>
                      </Wrap>
                      <span style={{ padding: 8 }} />
                      <Wrap className="label">
                        <BoxHeader>
                          <span className="boxText">
                            Numeração exata da extensão de bloqueio
                          </span>
                        </BoxHeader>
                        <Wrap>
                          <Input
                            type="number"
                            name="inicio_numeracao_bloqueio_externa"
                            label="De"
                            onChange={handleChange}
                            required
                            defaultValue={
                              dadoState?.viewData &&
                              responseLocation?.inicio_numeracao_bloqueio_externa
                            }
                            disabled={dadoState?.viewData && true}
                          />
                          <Input
                            type="number"
                            name="fim_numeracao_bloqueio_externa"
                            label="Até"
                            onChange={handleChange}
                            required
                            defaultValue={
                              dadoState?.viewData &&
                              responseLocation?.fim_numeracao_bloqueio_externa
                            }
                            disabled={dadoState?.viewData && true}
                          />
                        </Wrap>
                      </Wrap>
                    </Wrap>
                  </ConditionalContainer>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Haverá alguma intervenção de arte no local?"
                      onClickTrue={handleIntervencaoArteTrue}
                      onClickFalse={handleIntervencaoArteFalse}
                      selected={intervencaoArte}
                      isDisabled={dadoState?.viewData && true}
                      error={
                        errorsForm?.intervencaoArte === true && 'Obrigatório'
                      }
                    />
                  </LimiterInputWidth>
                </Wrap>

                <ConditionalContainer show={intervencaoArte === true}>
                  <Wrap>
                    <Textarea
                      type="text"
                      name="desc_intervencao_arte"
                      label="Descreva a(s) intervenção(ões)"
                      onChange={value => {
                        handleChange(value);
                      }}
                      required
                      rows="2"
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.locacao_default?.desc_intervencao_arte
                      }
                      disabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                  <Wrap>
                    <File
                      label="Relatório de Arte:"
                      attach={dataRelatorioArteFile}
                      textFile="Nenhum arquivo selecionado"
                      name="relatorio_arte_file"
                      inputRef={relatorioArteFileRef}
                      onChange={handleFileChange}
                      onClick={handleRelatorioArteFile}
                      error={
                        errorsForm?.relatorioArteFile === true && 'Obrigatório, tamanho máximo 20MB'
                      }
                      link={fileArte?.length > 0 && fileArte[0].url}
                      isDisabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w50>
                    <Select
                      name="ld_equipamento_filmagem"
                      label="Qual a sua estrutura e equipamentos de filmagem:"
                      placeholder="Selecione"
                      options={equipamentosSelectList}
                      style={selectCustomStyles}
                      onChange={handleMultiSelectEquipamentos}
                      required
                      isMulti
                      isDisabled={dadoState?.viewData && true}
                    />
                  </LimiterInputWidth>
                  <ConditionalContainer show={showOutroEquipamentoField}>
                    <LimiterInputWidth w50>
                      <Input
                        type="text"
                        name="outro_equipamento"
                        label="Outro Equipamento"
                        required
                        onChange={handleChange}
                        defaultValue={
                          responseLocation?.locacao_default?.outro_equipamento
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </LimiterInputWidth>
                  </ConditionalContainer>
                </Wrap>

                <ConditionalContainer show={showDescrEquipamentoFilmagemField}>
                  <Wrap>
                    <Textarea
                      label="Descreva a(s) extensão(ões)"
                      required
                      name="descricoes_equipamento_filmagem"
                      onChange={handleChange}
                      rows="3"
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.locacao_default
                          ?.descricoes_equipamento_filmagem
                      }
                      disabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Haverá gerador?"
                      onClickTrue={handleGeradorTrue}
                      onClickFalse={handleGeradorFalse}
                      selected={gerador}
                      isDisabled={dadoState?.viewData && true}
                      error={errorsForm?.gerador === true && 'Obrigatório'}
                    />
                  </LimiterInputWidth>

                  <ConditionalContainer show={gerador === true}>
                    <LimiterInputWidth w50>
                      <ChoiceButtonLocacao
                        label="Blimpado/Silencioso ou Não-Blimpado?"
                        onClickTrue={handleBlimpadorTrue}
                        onClickFalse={handleBlimpadorFalse}
                        selected={blimpado}
                        isDisabled={dadoState?.viewData && true}
                        error={errorsForm?.blimpado === true && 'Obrigatório'}
                        yesLabelValue="Blimpado"
                        noLabelValue="Não-Blimpado"
                      />
                    </LimiterInputWidth>
                  </ConditionalContainer>
                </Wrap>
                <ConditionalContainer show={gerador === true}>
                  <Wrap>
                    <LimiterInputWidth w50>
                      <Select
                        name="ld_local_gerador_uuid"
                        label="O gerador ficará:"
                        placeholder="Selecione"
                        style={selectCustomStyles}
                        options={localGeradorSelectList}
                        required
                        onChange={value => {
                          handleSelectChange('ld_local_gerador_uuid', value);
                        }}
                        isDisabled={dadoState?.viewData && true}
                      />
                    </LimiterInputWidth>
                  </Wrap>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Precisará montar Base de Apoio no local?"
                      onClickTrue={handleBaseLocalTrue}
                      onClickFalse={handleBaseLocalFalse}
                      selected={baseLocal}
                      required
                      isDisabled={dadoState?.viewData && true}
                      error={errorsForm.baseLocal === true && 'Obrigatório'}
                    />
                  </LimiterInputWidth>
                </Wrap>

                <ConditionalContainer show={baseLocal}>
                  <Wrap style={{ marginBottom: 0 }}>
                    <LimiterInputWidth w50>
                      <Select
                        name="ld_finalidade_base_apoio"
                        label="Selecione as Finalidades"
                        placeholder="Selecione"
                        options={finalidadeSelectList}
                        style={selectCustomStyles}
                        required
                        onChange={handleMultiSelectFinalidades}
                        isMulti
                        isDisabled={dadoState?.viewData && true}
                      />
                    </LimiterInputWidth>
                    <ConditionalContainer show={showOutroFinalidadeField}>
                      <Input
                        type="text"
                        name="outro_finalidade"
                        label="Outra Finalidade"
                        onChange={handleChange}
                        required
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default.outro_finalidade
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </ConditionalContainer>
                  </Wrap>

                  <Wrap style={{ alignItems: 'flex-end' }}>
                    <LimiterInputWidth w50>
                      <Input
                        type="text"
                        name="local_base_apoio"
                        label="Descreva local da base de apoio"
                        onChange={handleChange}
                        required
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default.local_base_apoio
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </LimiterInputWidth>

                    <LimiterInputWidth w25 style={{ marginRight: 0 }}>
                      <Input
                        type="number"
                        step="0.01"
                        name="dimensao_base_apoio"
                        label="Descreva a dimensão estimada da área"
                        onChange={handleChange}
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default.dimensao_base_apoio
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </LimiterInputWidth>

                    <BoxHeader style={{ justifyContent: 'center', width: 50 }}>
                      <span className="boxText" style={{ color: '#828282' }}>
                        ou
                      </span>
                    </BoxHeader>

                    <LimiterInputWidth w25>
                      <Input
                        type="number"
                        name="quantidade_barracas"
                        label="Descreva a quantidade de barracas a serem montadas"
                        onChange={handleChange}
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default.quantidade_barracas
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </LimiterInputWidth>
                  </Wrap>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w25>
                    <ChoiceButtonLocacao
                      label="Captação de som direto?"
                      onClickTrue={handleCaptacaoSomDiretoTrue}
                      onClickFalse={handleCaptacaoSomDiretoFalse}
                      selected={captacaoSomDireto}
                      required
                      isDisabled={dadoState?.viewData && true}
                      error={
                        errorsForm.captacaoSomDireto === true && 'Obrigatório'
                      }
                    />
                  </LimiterInputWidth>
                </Wrap>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Haverá som na filmagem?"
                      onClickTrue={handleSomFilmagemTrue}
                      onClickFalse={handleSomFilmagemFalse}
                      selected={somFilmagem}
                      required
                      error={errorsForm?.somFilmagem === true && 'Obrigatório'}
                      isDisabled={dadoState?.viewData && true}
                    />
                  </LimiterInputWidth>
                </Wrap>

                <ConditionalContainer show={somFilmagem}>
                  <Wrap>
                    <LimiterInputWidth w75>
                      <Select
                        name="ld_som_filmagem"
                        label="Sons de Filmagem"
                        placeholder="Selecione"
                        style={selectCustomStyles}
                        required
                        options={somFilmagemSelectList}
                        onChange={handleMultiSelectSomFilmagem}
                        isMulti
                        isDisabled={dadoState?.viewData && true}
                      />
                    </LimiterInputWidth>
                  </Wrap>

                  <ConditionalContainer show={showOutroSomFilmagemField}>
                    <Wrap>
                      <Input
                        type="text"
                        name="outro_som_filmagem"
                        label="Outro Som de Filmagem"
                        onChange={handleChange}
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default?.outro_som_filmagem
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </Wrap>
                  </ConditionalContainer>

                  <ConditionalContainer show={showDescrSomFilmagemField}>
                    <Wrap>
                      <Textarea
                        label="Descreva a(s) característica(s)"
                        required
                        name="descricoes_som_filmagem"
                        onChange={handleChange}
                        rows="3"
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default
                            ?.descricoes_som_filmagem
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </Wrap>
                  </ConditionalContainer>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w25>
                    <ChoiceButtonLocacao
                      label="Drone"
                      onClickTrue={handleDroneTue}
                      onClickFalse={handleDroneFalse}
                      selected={drone}
                      isDisabled={dadoState?.viewData && true}
                      error={errorsForm?.drone === true && 'Obrigatório'}
                    />
                  </LimiterInputWidth>
                </Wrap>

                {drone === true && (
                  <Wrap>
                    <Textarea
                      name="autorizacao_drones"
                      onChange={handleChange}
                      rows="4"
                      value="Para filmagens com drones: o Espaço Aéreo não é de administração municipal, mas sim da
                      Federação/União, portanto, não faz parte do campo de atuação da SPFilm. A autorização para o uso
                      de drones deve ser solicitada diretamente à Agência Nacional de Aviação Civil (ANAC), mediante
                      cadastro no Sistema SARPAS, disponibilizado no site do Departamento de Controle do Espaço Aéreo
                      (DECEA)."
                      disabled
                    />
                  </Wrap>
                )}

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Efeitos Especiais"
                      onClickTrue={handleEfeitosEspeciaisTrue}
                      onClickFalse={handleEfeitosEspeciaisFalse}
                      selected={efeitosEspeciais}
                      isDisabled={dadoState?.viewData && true}
                      error={
                        errorsForm?.efeitosEspeciais === true && 'Obrigatório'
                      }
                    />
                  </LimiterInputWidth>

                  <ConditionalContainer show={efeitosEspeciais === true}>
                    <Select
                      name="ld_efeitos_especiais_uuid"
                      label="Efeitos Especiais"
                      placeholder="Selecione"
                      style={selectCustomStyles}
                      options={efeitoEspecialSelectList}
                      onChange={value => {
                        handleSelectChange('ld_efeitos_especiais_uuid', value);
                      }}
                      required
                      isDisabled={dadoState?.viewData && true}
                    />
                  </ConditionalContainer>
                </Wrap>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Haverá projeção visível a partir de logradouro público?"
                      onClickTrue={handleProjecaoTrue}
                      onClickFalse={handleProjecaoFalse}
                      selected={projecao}
                      isDisabled={dadoState?.viewData && true}
                      error={errorsForm?.projecao === true && 'Obrigatório'}
                    />
                  </LimiterInputWidth>
                </Wrap>

                <Wrap>
                  <ConditionalContainer show={projecao === true}>
                    <File
                      label="Campo para upload do conteúdo da projeção"
                      attach={dataConteudoProjecaoFile}
                      textFile="Nenhum arquivo selecionado"
                      name="conteudo_projecao_file"
                      inputRef={conteudoProjecaoRef}
                      onChange={handleFileChange}
                      onClick={handleProjecaoFile}
                      error={
                        errorsForm?.conteudoProjecaoFile === true &&
                        'Obrigatório, tamanho máximo 20MB'
                      }
                      link={fileProjecao?.length > 0 && fileProjecao[0].url}
                      isDisabled={dadoState?.viewData && true}
                    />
                  </ConditionalContainer>
                </Wrap>

                <ConditionalContainer show={projecao === true}>
                  <Wrap>
                    <LimiterInputWidth w50>
                      <ChoiceButtonLocacao
                        label="Será projetado em imóvel público ou privado?"
                        onClickTrue={handlePublicoPrivadoTrue}
                        onClickFalse={handlePublicoPrivadoFalse}
                        selected={publicoPrivado}
                        isDisabled={dadoState?.viewData && true}
                        error={
                          errorsForm?.publicoPrivado === true && 'Obrigatório'
                        }
                        yesLabelValue="Público"
                        noLabelValue="Privado"
                      />
                    </LimiterInputWidth>
                  </Wrap>
                  <Wrap>
                    <Textarea
                      type="text"
                      name="estrutura_projecao"
                      label="Descreva a estrutura para projeção"
                      onChange={handleChange}
                      required
                      rows="3"
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.locacao_default?.estrutura_projecao
                      }
                      disabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                  <Wrap>
                    <Textarea
                      type="text"
                      name="instalacao_estrutura_projecao"
                      label="Descreva local de instalação para estrutura de projeção"
                      onChange={handleChange}
                      required
                      rows="3"
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.locacao_default
                          ?.instalacao_estrutura_projecao
                      }
                      disabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                  <Wrap>
                    <LimiterInputWidth w50>
                      <ChoiceButtonLocacao
                        label="Haverá exibição de logomarca na projeção? Se sim, qual porcentagem ocupará da área total da projeção e por quanto tempo será projetada?"
                        onClickTrue={handleProjecaoLogoTrue}
                        onClickFalse={handleProjecaoLogoFalse}
                        selected={projecaoLogo}
                        isDisabled={dadoState?.viewData && true}
                        error={
                          errorsForm?.projecaoLogo === true && 'Obrigatório'
                        }
                      />
                    </LimiterInputWidth>
                  </Wrap>
                  <ConditionalContainer show={projecaoLogo === true}>
                    <Wrap>
                      <Input
                        type="number"
                        step="0.01"
                        name="porcentagem_projecao"
                        label="Porcentagem que a projeção irá ocupar"
                        onChange={handleChange}
                        required
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default
                            ?.porcentagem_projecao
                        }
                        disabled={dadoState?.viewData && true}
                      />
                      <Input
                        type="time"
                        name="area_tempo_projeção"
                        label="Tempo de Projeção"
                        required
                        onChange={handleChange}
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default?.area_tempo_projeção
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </Wrap>
                  </ConditionalContainer>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Haverá desligamento de iluminação no local?"
                      onClickTrue={handleDesligarLuzTrue}
                      onClickFalse={handleDesligarLuzFalse}
                      selected={desligarLuz}
                      isDisabled={dadoState?.viewData && true}
                      error={errorsForm?.desligarLuz === true && 'Obrigatório'}
                    />
                  </LimiterInputWidth>
                </Wrap>

                <ConditionalContainer show={desligarLuz}>
                  <Wrap>
                    <File
                      label="Arquivo do local:"
                      attach={dataIluminacaoFile}
                      textFile="Nenhum arquivo selecionado"
                      name="iluminacao_file"
                      inputRef={iluminacaoFileRef}
                      onChange={handleFileChange}
                      onClick={handleIluminacaoFile}
                      error={
                        errorsForm?.iluminacaoFile === true && 'Obrigatório, tamanho máximo 20MB'
                      }
                      link={fileLuz?.length > 0 && fileLuz[0].url}
                      isDisabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                </ConditionalContainer>

                <Wrap>
                  <Input
                    type="text"
                    name="especificidades"
                    label="Descreva especificidades não contempladas nas perguntas acima"
                    onChange={handleChange}
                    defaultValue={
                      dadoState?.viewData &&
                      responseLocation?.locacao_default?.especificidades
                    }
                    disabled={dadoState?.viewData && true}
                  />
                </Wrap>

                <Wrap style={{ flexDirection: 'column' }}>
                  {dadoState?.viewData && reservasVagas ? (
                    <>
                      <LimiterInputWidth w50>
                        <Select
                          name="reservas_vagas_locacao"
                          label="Reservas de Vagas"
                          placeholder="Selecione"
                          options={responseLocation?.locacao_via_externa?.map(
                            ({
                              uuid,
                              address,
                              number,
                              neighborhood,
                              endpoint,
                            }) => ({
                              label: `${address}, ${number}, ${neighborhood}`,
                              value: { uuid, endpoint },
                            }),
                          )}
                          style={selectCustomStyles}
                          onChange={value => {
                            handleSelectChange('reservas_vagas_locacao', value);
                          }}
                        />
                      </LimiterInputWidth>

                      {formData?.reservas_vagas_locacao && (
                        <Wrap>
                          <FormChoiceButton
                            nomeProjeto={dadoState?.nome_projeto}
                            viewData={{
                              is_admin: isAdminRequest,
                              uuid: formData?.reservas_vagas_locacao?.uuid,
                              endpoint: 'reservas-vagas-vinculado',
                            }}
                          />
                        </Wrap>
                      )}
                    </>
                  ) : (
                    <ChoiceButtonLocacao
                      label="Necessita de reserva de vagas em via próxima?"
                      onClickTrue={handleReservasVagasTrue}
                      onClickFalse={handleReservasVagasFalse}
                      selected={reservasVagas}
                      required
                      isDisabled={dadoState?.viewData && true}
                      error={errorsForm.reservasVagas === true && 'Obrigatório'}
                    />
                  )}
                </Wrap>

                {responseLocation?.documents?.length > 0 && isAdminRequest && (
                  <Wrap>
                    <Documents
                      documents={responseLocation?.documents}
                      uuid={responseLocation.uuid}
                    />
                  </Wrap>
                )}

                {responseLocation?.created_at && isAdminRequest && (
                  <Wrap>
                    <LimiterInputWidth w50>
                      <Input
                        type="text"
                        name="created_at"
                        label="Data de criação"
                        defaultValue={format(
                          new Date(responseLocation?.created_at),
                          'dd/MM/yyyy HH:mm',
                        )}
                        disabled
                      />
                    </LimiterInputWidth>
                  </Wrap>
                )}
              </WhiteBox>

              <Chat
                uuid={responseLocation?.locacao_default?.uuid}
                chatKeyFilter="locacao_default"
                locacaoNameView={responseLocation?.name_view}
              />

              {responseLocation?.valor_locacao && isAdminRequest && (
                <ValorLocacao
                  locacaoEndpoint={dadoState?.viewData?.endpoint}
                  locacaoUuid={responseLocation?.uuid}
                  viewData={responseLocation?.valor_locacao}
                />
              )}

              {responseLocation && isAdminRequest && (
                <ModalidadePagamento
                  locacaoEndpoint={dadoState?.viewData?.endpoint}
                  locacaoUuid={responseLocation?.uuid}
                  viewData={responseLocation?.modalidade_pagamento}
                />
              )}

              {responseLocation && isAdminRequest && (
                <WorkStatusSwitch
                  data={{
                    entity: 'locacao-default',
                    uuid: responseLocation?.locacao_default?.uuid,
                  }}
                />
              )}

              {responseLocation && isAdminRequest && (
                <ObservacoesChat workUuid={responseLocation?.work_uuid} />
              )}

              {dadoState?.uuid && !dadoState.viewData && (
                <Button
                  type="submit"
                  btType="#26A2B1"
                  label="Enviar"
                  full
                  width="140px"
                  loading={loading}
                  style={{ position: 'relative', bottom: '35px' }}
                  disabled={loading}
                />
              )}

              {Object.keys(responseLocation || {}).length > 0 && (
                <Link
                  to={{
                    pathname: 'redireciona-endpoint',
                    search: `query=${encodeURIComponent(
                      CryptoJS.AES.encrypt(
                        JSON.stringify({
                          is_admin: isAdminRequest,
                          uuid: responseLocation?.uuid,
                          endpoint: responseLocation?.endpoint,
                          mode: 'edit',
                          nome_projeto: responseLocation?.titulo_obra,
                        }),
                        tenancy_env('REACT_APP_API_BASE_URL'),
                      ).toString(),
                    )}`,
                  }}
                  target="_blank"
                  style={{
                    textDecoration: 'none',
                    width: '100%',
                    maxWidth: '140px',
                    position: 'relative',
                    bottom: '35px',
                  }}
                >
                  <ActionButton
                    style={{
                      backgroundColor: '#828282',
                    }}
                  >
                    Editar
                  </ActionButton>
                </Link>
              )}
            </Form>
          </PageContent>
        </PageContainer>
      </>
    );
  }

  return (
    <>
      <Header>
        <LogoIcon />
        {!isAdminRequest && <NavBarHeader />}
      </Header>

      <BannerHeader>
        <BannerContent>
          <TextBanner>
            <h1>
              Filmagens (ou apoio) em
              ruas/calçadas/vias/viadutos/passarelas/túneis/correlatos
            </h1>
            {!isAdminRequest && (
              <span>
                Home | Obras | {dadoState?.nome_projeto} | Locações | Filmagens
                (ou apoio) em
                ruas/calçadas/vias/viadutos/passarelas/túneis/correlatos
              </span>
            )}
          </TextBanner>
        </BannerContent>
      </BannerHeader>

      {renderLocacao()}

      <PageFooter>
        <img
          src={clientResources.images.system.spcineLogo}
          alt={clientResources.images.system.altLogo}
        />
        <img
          src={clientResources.images.system.culturaSpLogo}
          alt={clientResources.images.system.altCultura}
        />
      </PageFooter>

      <ModalPorteFilmagem
        openModal={openModalPorteFilmagem}
        closeModal={() => setOpenModalPorteFilmagem(false)}
      />
    </>
  );
}
